(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1e47"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1e47"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("nmac8", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = "Expected a function";
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__["delete"](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function baseGt(value, other) {
    return value > other;
}
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) return false;
        }
    }
    return true;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
    };
}
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value) {
    return isArray(value) ? value : stringToPath(value);
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var result, index = -1, length = path.length;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result) return result;
    var length = object ? object.length : 0;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoize(function(string) {
    string = toString(string);
    var result = [];
    if (reLeadingDot.test(string)) result.push("");
    string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
memoize.Cache = MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : "";
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */ function maxBy(array, iteratee) {
    return array && array.length ? baseExtremum(array, baseIteratee(iteratee, 2), baseGt) : undefined;
}
module.exports = maxBy;

});

function $046ac80fccd9af81$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $6bdeba009fe4f140$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $046ac80fccd9af81$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $c819c676e77e1119$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c819c676e77e1119$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $c819c676e77e1119$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 *
 * Main lit-html module.
 *
 * Main exports:
 *
 * -  [[html]]
 * -  [[svg]]
 * -  [[render]]
 *
 * @packageDocumentation
 */ /**
 * Do not remove this comment; it keeps typedoc from misplacing the module
 * docs.
 */ /**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ const $2ba2127115d9c448$var$directives = new WeakMap();
const $2ba2127115d9c448$export$99b43ad1ed32e735 = (f)=>(...args)=>{
        const d = f(...args);
        $2ba2127115d9c448$var$directives.set(d, true);
        return d;
    };
const $2ba2127115d9c448$export$4b5d79f26e0e3ad5 = (o)=>{
    return typeof o === "function" && $2ba2127115d9c448$var$directives.has(o);
};


/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * True if the custom elements polyfill is in use.
 */ const $d82f0725bc6518e6$export$52a61c3a7415f2b1 = typeof window !== "undefined" && window.customElements != null && window.customElements.polyfillWrapFlushCallback !== undefined;
const $d82f0725bc6518e6$export$4cae3494608af418 = (container, start, end = null, before = null)=>{
    while(start !== end){
        const n = start.nextSibling;
        container.insertBefore(start, before);
        start = n;
    }
};
const $d82f0725bc6518e6$export$77f49a256021c8de = (container, start, end = null)=>{
    while(start !== end){
        const n = start.nextSibling;
        container.removeChild(start);
        start = n;
    }
};


/**
 * @license
 * Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * A sentinel value that signals that a value was handled by a directive and
 * should not be written to the DOM.
 */ const $b4e7c8434a1b94a6$export$9c068ae9cc5db4e8 = {};
const $b4e7c8434a1b94a6$export$45b790e32b2810ee = {};


/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ 
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * An expression marker with embedded unique key to avoid collision with
 * possible text in templates.
 */ const $1a9f99abf043bcce$export$ffc4d0086f1a4c9 = `{{lit-${String(Math.random()).slice(2)}}}`;
const $1a9f99abf043bcce$export$36b8314a2f34ed60 = `<!--${$1a9f99abf043bcce$export$ffc4d0086f1a4c9}-->`;
const $1a9f99abf043bcce$export$8c751b9db6965af4 = new RegExp(`${$1a9f99abf043bcce$export$ffc4d0086f1a4c9}|${$1a9f99abf043bcce$export$36b8314a2f34ed60}`);
const $1a9f99abf043bcce$export$552ff45b274cc170 = "$lit$";
class $1a9f99abf043bcce$export$14416b8d99d47caa {
    constructor(result, element){
        this.parts = [];
        this.element = element;
        const nodesToRemove = [];
        const stack = [];
        // Edge needs all 4 parameters present; IE11 needs 3rd parameter to be null
        const walker = document.createTreeWalker(element.content, 133 /* NodeFilter.SHOW_{ELEMENT|COMMENT|TEXT} */ , null, false);
        // Keeps track of the last index associated with a part. We try to delete
        // unnecessary nodes, but we never want to associate two different parts
        // to the same index. They must have a constant node between.
        let lastPartIndex = 0;
        let index = -1;
        let partIndex = 0;
        const { strings: strings, values: { length: length } } = result;
        while(partIndex < length){
            const node = walker.nextNode();
            if (node === null) {
                // We've exhausted the content inside a nested template element.
                // Because we still have parts (the outer for-loop), we know:
                // - There is a template in the stack
                // - The walker will find a nextNode outside the template
                walker.currentNode = stack.pop();
                continue;
            }
            index++;
            if (node.nodeType === 1 /* Node.ELEMENT_NODE */ ) {
                if (node.hasAttributes()) {
                    const attributes = node.attributes;
                    const { length: length } = attributes;
                    // Per
                    // https://developer.mozilla.org/en-US/docs/Web/API/NamedNodeMap,
                    // attributes are not guaranteed to be returned in document order.
                    // In particular, Edge/IE can return them out of order, so we cannot
                    // assume a correspondence between part index and attribute index.
                    let count = 0;
                    for(let i = 0; i < length; i++)if ($1a9f99abf043bcce$var$endsWith(attributes[i].name, $1a9f99abf043bcce$export$552ff45b274cc170)) count++;
                    while(count-- > 0){
                        // Get the template literal section leading up to the first
                        // expression in this attribute
                        const stringForPart = strings[partIndex];
                        // Find the attribute name
                        const name = $1a9f99abf043bcce$export$a5d53adfffe6a300.exec(stringForPart)[2];
                        // Find the corresponding attribute
                        // All bound attributes have had a suffix added in
                        // TemplateResult#getHTML to opt out of special attribute
                        // handling. To look up the attribute value we also need to add
                        // the suffix.
                        const attributeLookupName = name.toLowerCase() + $1a9f99abf043bcce$export$552ff45b274cc170;
                        const attributeValue = node.getAttribute(attributeLookupName);
                        node.removeAttribute(attributeLookupName);
                        const statics = attributeValue.split($1a9f99abf043bcce$export$8c751b9db6965af4);
                        this.parts.push({
                            type: "attribute",
                            index: index,
                            name: name,
                            strings: statics
                        });
                        partIndex += statics.length - 1;
                    }
                }
                if (node.tagName === "TEMPLATE") {
                    stack.push(node);
                    walker.currentNode = node.content;
                }
            } else if (node.nodeType === 3 /* Node.TEXT_NODE */ ) {
                const data = node.data;
                if (data.indexOf($1a9f99abf043bcce$export$ffc4d0086f1a4c9) >= 0) {
                    const parent = node.parentNode;
                    const strings = data.split($1a9f99abf043bcce$export$8c751b9db6965af4);
                    const lastIndex = strings.length - 1;
                    // Generate a new text node for each literal section
                    // These nodes are also used as the markers for node parts
                    for(let i = 0; i < lastIndex; i++){
                        let insert;
                        let s = strings[i];
                        if (s === "") insert = $1a9f99abf043bcce$export$46b32044f78fe9b1();
                        else {
                            const match = $1a9f99abf043bcce$export$a5d53adfffe6a300.exec(s);
                            if (match !== null && $1a9f99abf043bcce$var$endsWith(match[2], $1a9f99abf043bcce$export$552ff45b274cc170)) s = s.slice(0, match.index) + match[1] + match[2].slice(0, -$1a9f99abf043bcce$export$552ff45b274cc170.length) + match[3];
                            insert = document.createTextNode(s);
                        }
                        parent.insertBefore(insert, node);
                        this.parts.push({
                            type: "node",
                            index: ++index
                        });
                    }
                    // If there's no text, we must insert a comment to mark our place.
                    // Else, we can trust it will stick around after cloning.
                    if (strings[lastIndex] === "") {
                        parent.insertBefore($1a9f99abf043bcce$export$46b32044f78fe9b1(), node);
                        nodesToRemove.push(node);
                    } else node.data = strings[lastIndex];
                    // We have a part for each match found
                    partIndex += lastIndex;
                }
            } else if (node.nodeType === 8 /* Node.COMMENT_NODE */ ) {
                if (node.data === $1a9f99abf043bcce$export$ffc4d0086f1a4c9) {
                    const parent = node.parentNode;
                    // Add a new marker node to be the startNode of the Part if any of
                    // the following are true:
                    //  * We don't have a previousSibling
                    //  * The previousSibling is already the start of a previous part
                    if (node.previousSibling === null || index === lastPartIndex) {
                        index++;
                        parent.insertBefore($1a9f99abf043bcce$export$46b32044f78fe9b1(), node);
                    }
                    lastPartIndex = index;
                    this.parts.push({
                        type: "node",
                        index: index
                    });
                    // If we don't have a nextSibling, keep this node so we have an end.
                    // Else, we can remove it to save future costs.
                    if (node.nextSibling === null) node.data = "";
                    else {
                        nodesToRemove.push(node);
                        index--;
                    }
                    partIndex++;
                } else {
                    let i = -1;
                    while((i = node.data.indexOf($1a9f99abf043bcce$export$ffc4d0086f1a4c9, i + 1)) !== -1){
                        // Comment node has a binding marker inside, make an inactive part
                        // The binding won't work, but subsequent bindings will
                        // TODO (justinfagnani): consider whether it's even worth it to
                        // make bindings in comments work
                        this.parts.push({
                            type: "node",
                            index: -1
                        });
                        partIndex++;
                    }
                }
            }
        }
        // Remove text binding nodes after the walk to not disturb the TreeWalker
        for (const n of nodesToRemove)n.parentNode.removeChild(n);
    }
}
const $1a9f99abf043bcce$var$endsWith = (str, suffix)=>{
    const index = str.length - suffix.length;
    return index >= 0 && str.slice(index) === suffix;
};
const $1a9f99abf043bcce$export$93919229d19012c8 = (part)=>part.index !== -1;
const $1a9f99abf043bcce$export$46b32044f78fe9b1 = ()=>document.createComment("");
const $1a9f99abf043bcce$export$a5d53adfffe6a300 = // eslint-disable-next-line no-control-regex
/([ \x09\x0a\x0c\x0d])([^\0-\x1F\x7F-\x9F "'>=/]+)([ \x09\x0a\x0c\x0d]*=[ \x09\x0a\x0c\x0d]*(?:[^ \x09\x0a\x0c\x0d"'`<>=]*|"[^"]*|'[^']*))$/;


class $5f91f2bbd7c940b0$export$6eecef7813f38266 {
    update(values) {
        let i = 0;
        for (const part of this.__parts){
            if (part !== undefined) part.setValue(values[i]);
            i++;
        }
        for (const part of this.__parts)if (part !== undefined) part.commit();
    }
    _clone() {
        // There are a number of steps in the lifecycle of a template instance's
        // DOM fragment:
        //  1. Clone - create the instance fragment
        //  2. Adopt - adopt into the main document
        //  3. Process - find part markers and create parts
        //  4. Upgrade - upgrade custom elements
        //  5. Update - set node, attribute, property, etc., values
        //  6. Connect - connect to the document. Optional and outside of this
        //     method.
        //
        // We have a few constraints on the ordering of these steps:
        //  * We need to upgrade before updating, so that property values will pass
        //    through any property setters.
        //  * We would like to process before upgrading so that we're sure that the
        //    cloned fragment is inert and not disturbed by self-modifying DOM.
        //  * We want custom elements to upgrade even in disconnected fragments.
        //
        // Given these constraints, with full custom elements support we would
        // prefer the order: Clone, Process, Adopt, Upgrade, Update, Connect
        //
        // But Safari does not implement CustomElementRegistry#upgrade, so we
        // can not implement that order and still have upgrade-before-update and
        // upgrade disconnected fragments. So we instead sacrifice the
        // process-before-upgrade constraint, since in Custom Elements v1 elements
        // must not modify their light DOM in the constructor. We still have issues
        // when co-existing with CEv0 elements like Polymer 1, and with polyfills
        // that don't strictly adhere to the no-modification rule because shadow
        // DOM, which may be created in the constructor, is emulated by being placed
        // in the light DOM.
        //
        // The resulting order is on native is: Clone, Adopt, Upgrade, Process,
        // Update, Connect. document.importNode() performs Clone, Adopt, and Upgrade
        // in one step.
        //
        // The Custom Elements v1 polyfill supports upgrade(), so the order when
        // polyfilled is the more ideal: Clone, Process, Adopt, Upgrade, Update,
        // Connect.
        const fragment = (0, $d82f0725bc6518e6$export$52a61c3a7415f2b1) ? this.template.element.content.cloneNode(true) : document.importNode(this.template.element.content, true);
        const stack = [];
        const parts = this.template.parts;
        // Edge needs all 4 parameters present; IE11 needs 3rd parameter to be null
        const walker = document.createTreeWalker(fragment, 133 /* NodeFilter.SHOW_{ELEMENT|COMMENT|TEXT} */ , null, false);
        let partIndex = 0;
        let nodeIndex = 0;
        let part;
        let node = walker.nextNode();
        // Loop through all the nodes and parts of a template
        while(partIndex < parts.length){
            part = parts[partIndex];
            if (!(0, $1a9f99abf043bcce$export$93919229d19012c8)(part)) {
                this.__parts.push(undefined);
                partIndex++;
                continue;
            }
            // Progress the tree walker until we find our next part's node.
            // Note that multiple parts may share the same node (attribute parts
            // on a single element), so this loop may not run at all.
            while(nodeIndex < part.index){
                nodeIndex++;
                if (node.nodeName === "TEMPLATE") {
                    stack.push(node);
                    walker.currentNode = node.content;
                }
                if ((node = walker.nextNode()) === null) {
                    // We've exhausted the content inside a nested template element.
                    // Because we still have parts (the outer for-loop), we know:
                    // - There is a template in the stack
                    // - The walker will find a nextNode outside the template
                    walker.currentNode = stack.pop();
                    node = walker.nextNode();
                }
            }
            // We've arrived at our part's node.
            if (part.type === "node") {
                const part = this.processor.handleTextExpression(this.options);
                part.insertAfterNode(node.previousSibling);
                this.__parts.push(part);
            } else this.__parts.push(...this.processor.handleAttributeExpressions(node, part.name, part.strings, this.options));
            partIndex++;
        }
        if (0, $d82f0725bc6518e6$export$52a61c3a7415f2b1) {
            document.adoptNode(fragment);
            customElements.upgrade(fragment);
        }
        return fragment;
    }
    constructor(template, processor, options){
        this.__parts = [];
        this.template = template;
        this.processor = processor;
        this.options = options;
    }
}


/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * @module lit-html
 */ 

/**
 * Our TrustedTypePolicy for HTML which is declared using the html template
 * tag function.
 *
 * That HTML is a developer-authored constant, and is parsed with innerHTML
 * before any untrusted expressions have been mixed in. Therefor it is
 * considered safe by construction.
 */ const $763e43480b5302de$var$policy = window.trustedTypes && trustedTypes.createPolicy("lit-html", {
    createHTML: (s)=>s
});
const $763e43480b5302de$var$commentMarker = ` ${(0, $1a9f99abf043bcce$export$ffc4d0086f1a4c9)} `;
class $763e43480b5302de$export$ce95ebd39b69fb27 {
    /**
     * Returns a string of HTML used to create a `<template>` element.
     */ getHTML() {
        const l = this.strings.length - 1;
        let html = "";
        let isCommentBinding = false;
        for(let i = 0; i < l; i++){
            const s = this.strings[i];
            // For each binding we want to determine the kind of marker to insert
            // into the template source before it's parsed by the browser's HTML
            // parser. The marker type is based on whether the expression is in an
            // attribute, text, or comment position.
            //   * For node-position bindings we insert a comment with the marker
            //     sentinel as its text content, like <!--{{lit-guid}}-->.
            //   * For attribute bindings we insert just the marker sentinel for the
            //     first binding, so that we support unquoted attribute bindings.
            //     Subsequent bindings can use a comment marker because multi-binding
            //     attributes must be quoted.
            //   * For comment bindings we insert just the marker sentinel so we don't
            //     close the comment.
            //
            // The following code scans the template source, but is *not* an HTML
            // parser. We don't need to track the tree structure of the HTML, only
            // whether a binding is inside a comment, and if not, if it appears to be
            // the first binding in an attribute.
            const commentOpen = s.lastIndexOf("<!--");
            // We're in comment position if we have a comment open with no following
            // comment close. Because <-- can appear in an attribute value there can
            // be false positives.
            isCommentBinding = (commentOpen > -1 || isCommentBinding) && s.indexOf("-->", commentOpen + 1) === -1;
            // Check to see if we have an attribute-like sequence preceding the
            // expression. This can match "name=value" like structures in text,
            // comments, and attribute values, so there can be false-positives.
            const attributeMatch = (0, $1a9f99abf043bcce$export$a5d53adfffe6a300).exec(s);
            if (attributeMatch === null) // We're only in this branch if we don't have a attribute-like
            // preceding sequence. For comments, this guards against unusual
            // attribute values like <div foo="<!--${'bar'}">. Cases like
            // <!-- foo=${'bar'}--> are handled correctly in the attribute branch
            // below.
            html += s + (isCommentBinding ? $763e43480b5302de$var$commentMarker : (0, $1a9f99abf043bcce$export$36b8314a2f34ed60));
            else // For attributes we use just a marker sentinel, and also append a
            // $lit$ suffix to the name to opt-out of attribute-specific parsing
            // that IE and Edge do for style and certain SVG attributes.
            html += s.substr(0, attributeMatch.index) + attributeMatch[1] + attributeMatch[2] + (0, $1a9f99abf043bcce$export$552ff45b274cc170) + attributeMatch[3] + (0, $1a9f99abf043bcce$export$ffc4d0086f1a4c9);
        }
        html += this.strings[l];
        return html;
    }
    getTemplateElement() {
        const template = document.createElement("template");
        let value = this.getHTML();
        if ($763e43480b5302de$var$policy !== undefined) // this is secure because `this.strings` is a TemplateStringsArray.
        // TODO: validate this when
        // https://github.com/tc39/proposal-array-is-template-object is
        // implemented.
        value = $763e43480b5302de$var$policy.createHTML(value);
        template.innerHTML = value;
        return template;
    }
    constructor(strings, values, type, processor){
        this.strings = strings;
        this.values = values;
        this.type = type;
        this.processor = processor;
    }
}
class $763e43480b5302de$export$36e852975bbbeae0 extends $763e43480b5302de$export$ce95ebd39b69fb27 {
    getHTML() {
        return `<svg>${super.getHTML()}</svg>`;
    }
    getTemplateElement() {
        const template = super.getTemplateElement();
        const content = template.content;
        const svgElement = content.firstChild;
        content.removeChild(svgElement);
        (0, $d82f0725bc6518e6$export$4cae3494608af418)(content, svgElement.firstChild);
        return template;
    }
}



const $9aa32d02cdcaa670$export$c3825b437cbdea5c = (value)=>{
    return value === null || !(typeof value === "object" || typeof value === "function");
};
const $9aa32d02cdcaa670$export$9652023d9040757 = (value)=>{
    return Array.isArray(value) || // eslint-disable-next-line @typescript-eslint/no-explicit-any
    !!(value && value[Symbol.iterator]);
};
class $9aa32d02cdcaa670$export$9ac9216e336e96d0 {
    /**
     * Creates a single part. Override this to create a differnt type of part.
     */ _createPart() {
        return new $9aa32d02cdcaa670$export$da9b3ca39c846561(this);
    }
    _getValue() {
        const strings = this.strings;
        const l = strings.length - 1;
        const parts = this.parts;
        // If we're assigning an attribute via syntax like:
        //    attr="${foo}"  or  attr=${foo}
        // but not
        //    attr="${foo} ${bar}" or attr="${foo} baz"
        // then we don't want to coerce the attribute value into one long
        // string. Instead we want to just return the value itself directly,
        // so that sanitizeDOMValue can get the actual value rather than
        // String(value)
        // The exception is if v is an array, in which case we do want to smash
        // it together into a string without calling String() on the array.
        //
        // This also allows trusted values (when using TrustedTypes) being
        // assigned to DOM sinks without being stringified in the process.
        if (l === 1 && strings[0] === "" && strings[1] === "") {
            const v = parts[0].value;
            if (typeof v === "symbol") return String(v);
            if (typeof v === "string" || !$9aa32d02cdcaa670$export$9652023d9040757(v)) return v;
        }
        let text = "";
        for(let i = 0; i < l; i++){
            text += strings[i];
            const part = parts[i];
            if (part !== undefined) {
                const v = part.value;
                if ($9aa32d02cdcaa670$export$c3825b437cbdea5c(v) || !$9aa32d02cdcaa670$export$9652023d9040757(v)) text += typeof v === "string" ? v : String(v);
                else for (const t of v)text += typeof t === "string" ? t : String(t);
            }
        }
        text += strings[l];
        return text;
    }
    commit() {
        if (this.dirty) {
            this.dirty = false;
            this.element.setAttribute(this.name, this._getValue());
        }
    }
    constructor(element, name, strings){
        this.dirty = true;
        this.element = element;
        this.name = name;
        this.strings = strings;
        this.parts = [];
        for(let i = 0; i < strings.length - 1; i++)this.parts[i] = this._createPart();
    }
}
class $9aa32d02cdcaa670$export$da9b3ca39c846561 {
    setValue(value) {
        if (value !== (0, $b4e7c8434a1b94a6$export$9c068ae9cc5db4e8) && (!$9aa32d02cdcaa670$export$c3825b437cbdea5c(value) || value !== this.value)) {
            this.value = value;
            // If the value is a not a directive, dirty the committer so that it'll
            // call setAttribute. If the value is a directive, it'll dirty the
            // committer if it calls setValue().
            if (!(0, $2ba2127115d9c448$export$4b5d79f26e0e3ad5)(value)) this.committer.dirty = true;
        }
    }
    commit() {
        while((0, $2ba2127115d9c448$export$4b5d79f26e0e3ad5)(this.value)){
            const directive = this.value;
            this.value = (0, $b4e7c8434a1b94a6$export$9c068ae9cc5db4e8);
            directive(this);
        }
        if (this.value === (0, $b4e7c8434a1b94a6$export$9c068ae9cc5db4e8)) return;
        this.committer.commit();
    }
    constructor(committer){
        this.value = undefined;
        this.committer = committer;
    }
}
class $9aa32d02cdcaa670$export$a354997aeda6e93 {
    /**
     * Appends this part into a container.
     *
     * This part must be empty, as its contents are not automatically moved.
     */ appendInto(container) {
        this.startNode = container.appendChild((0, $1a9f99abf043bcce$export$46b32044f78fe9b1)());
        this.endNode = container.appendChild((0, $1a9f99abf043bcce$export$46b32044f78fe9b1)());
    }
    /**
     * Inserts this part after the `ref` node (between `ref` and `ref`'s next
     * sibling). Both `ref` and its next sibling must be static, unchanging nodes
     * such as those that appear in a literal section of a template.
     *
     * This part must be empty, as its contents are not automatically moved.
     */ insertAfterNode(ref) {
        this.startNode = ref;
        this.endNode = ref.nextSibling;
    }
    /**
     * Appends this part into a parent part.
     *
     * This part must be empty, as its contents are not automatically moved.
     */ appendIntoPart(part) {
        part.__insert(this.startNode = (0, $1a9f99abf043bcce$export$46b32044f78fe9b1)());
        part.__insert(this.endNode = (0, $1a9f99abf043bcce$export$46b32044f78fe9b1)());
    }
    /**
     * Inserts this part after the `ref` part.
     *
     * This part must be empty, as its contents are not automatically moved.
     */ insertAfterPart(ref) {
        ref.__insert(this.startNode = (0, $1a9f99abf043bcce$export$46b32044f78fe9b1)());
        this.endNode = ref.endNode;
        ref.endNode = this.startNode;
    }
    setValue(value) {
        this.__pendingValue = value;
    }
    commit() {
        if (this.startNode.parentNode === null) return;
        while((0, $2ba2127115d9c448$export$4b5d79f26e0e3ad5)(this.__pendingValue)){
            const directive = this.__pendingValue;
            this.__pendingValue = (0, $b4e7c8434a1b94a6$export$9c068ae9cc5db4e8);
            directive(this);
        }
        const value = this.__pendingValue;
        if (value === (0, $b4e7c8434a1b94a6$export$9c068ae9cc5db4e8)) return;
        if ($9aa32d02cdcaa670$export$c3825b437cbdea5c(value)) {
            if (value !== this.value) this.__commitText(value);
        } else if (value instanceof (0, $763e43480b5302de$export$ce95ebd39b69fb27)) this.__commitTemplateResult(value);
        else if (value instanceof Node) this.__commitNode(value);
        else if ($9aa32d02cdcaa670$export$9652023d9040757(value)) this.__commitIterable(value);
        else if (value === (0, $b4e7c8434a1b94a6$export$45b790e32b2810ee)) {
            this.value = (0, $b4e7c8434a1b94a6$export$45b790e32b2810ee);
            this.clear();
        } else // Fallback, will render the string representation
        this.__commitText(value);
    }
    __insert(node) {
        this.endNode.parentNode.insertBefore(node, this.endNode);
    }
    __commitNode(value) {
        if (this.value === value) return;
        this.clear();
        this.__insert(value);
        this.value = value;
    }
    __commitText(value) {
        const node = this.startNode.nextSibling;
        value = value == null ? "" : value;
        // If `value` isn't already a string, we explicitly convert it here in case
        // it can't be implicitly converted - i.e. it's a symbol.
        const valueAsString = typeof value === "string" ? value : String(value);
        if (node === this.endNode.previousSibling && node.nodeType === 3 /* Node.TEXT_NODE */ ) // If we only have a single text node between the markers, we can just
        // set its value, rather than replacing it.
        // TODO(justinfagnani): Can we just check if this.value is primitive?
        node.data = valueAsString;
        else this.__commitNode(document.createTextNode(valueAsString));
        this.value = value;
    }
    __commitTemplateResult(value) {
        const template = this.options.templateFactory(value);
        if (this.value instanceof (0, $5f91f2bbd7c940b0$export$6eecef7813f38266) && this.value.template === template) this.value.update(value.values);
        else {
            // Make sure we propagate the template processor from the TemplateResult
            // so that we use its syntax extension, etc. The template factory comes
            // from the render function options so that it can control template
            // caching and preprocessing.
            const instance = new (0, $5f91f2bbd7c940b0$export$6eecef7813f38266)(template, value.processor, this.options);
            const fragment = instance._clone();
            instance.update(value.values);
            this.__commitNode(fragment);
            this.value = instance;
        }
    }
    __commitIterable(value) {
        // For an Iterable, we create a new InstancePart per item, then set its
        // value to the item. This is a little bit of overhead for every item in
        // an Iterable, but it lets us recurse easily and efficiently update Arrays
        // of TemplateResults that will be commonly returned from expressions like:
        // array.map((i) => html`${i}`), by reusing existing TemplateInstances.
        // If _value is an array, then the previous render was of an
        // iterable and _value will contain the NodeParts from the previous
        // render. If _value is not an array, clear this part and make a new
        // array for NodeParts.
        if (!Array.isArray(this.value)) {
            this.value = [];
            this.clear();
        }
        // Lets us keep track of how many items we stamped so we can clear leftover
        // items from a previous render
        const itemParts = this.value;
        let partIndex = 0;
        let itemPart;
        for (const item of value){
            // Try to reuse an existing part
            itemPart = itemParts[partIndex];
            // If no existing part, create a new one
            if (itemPart === undefined) {
                itemPart = new $9aa32d02cdcaa670$export$a354997aeda6e93(this.options);
                itemParts.push(itemPart);
                if (partIndex === 0) itemPart.appendIntoPart(this);
                else itemPart.insertAfterPart(itemParts[partIndex - 1]);
            }
            itemPart.setValue(item);
            itemPart.commit();
            partIndex++;
        }
        if (partIndex < itemParts.length) {
            // Truncate the parts array so _value reflects the current state
            itemParts.length = partIndex;
            this.clear(itemPart && itemPart.endNode);
        }
    }
    clear(startNode = this.startNode) {
        (0, $d82f0725bc6518e6$export$77f49a256021c8de)(this.startNode.parentNode, startNode.nextSibling, this.endNode);
    }
    constructor(options){
        this.value = undefined;
        this.__pendingValue = undefined;
        this.options = options;
    }
}
class $9aa32d02cdcaa670$export$b9df278b293d5b48 {
    setValue(value) {
        this.__pendingValue = value;
    }
    commit() {
        while((0, $2ba2127115d9c448$export$4b5d79f26e0e3ad5)(this.__pendingValue)){
            const directive = this.__pendingValue;
            this.__pendingValue = (0, $b4e7c8434a1b94a6$export$9c068ae9cc5db4e8);
            directive(this);
        }
        if (this.__pendingValue === (0, $b4e7c8434a1b94a6$export$9c068ae9cc5db4e8)) return;
        const value = !!this.__pendingValue;
        if (this.value !== value) {
            if (value) this.element.setAttribute(this.name, "");
            else this.element.removeAttribute(this.name);
            this.value = value;
        }
        this.__pendingValue = (0, $b4e7c8434a1b94a6$export$9c068ae9cc5db4e8);
    }
    constructor(element, name, strings){
        this.value = undefined;
        this.__pendingValue = undefined;
        if (strings.length !== 2 || strings[0] !== "" || strings[1] !== "") throw new Error("Boolean attributes can only contain a single expression");
        this.element = element;
        this.name = name;
        this.strings = strings;
    }
}
class $9aa32d02cdcaa670$export$2d7935a96ad7cb22 extends $9aa32d02cdcaa670$export$9ac9216e336e96d0 {
    _createPart() {
        return new $9aa32d02cdcaa670$export$b78f5e1c476c794e(this);
    }
    _getValue() {
        if (this.single) return this.parts[0].value;
        return super._getValue();
    }
    commit() {
        if (this.dirty) {
            this.dirty = false;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.element[this.name] = this._getValue();
        }
    }
    constructor(element, name, strings){
        super(element, name, strings);
        this.single = strings.length === 2 && strings[0] === "" && strings[1] === "";
    }
}
class $9aa32d02cdcaa670$export$b78f5e1c476c794e extends $9aa32d02cdcaa670$export$da9b3ca39c846561 {
}
// Detect event listener options support. If the `capture` property is read
// from the options object, then options are supported. If not, then the third
// argument to add/removeEventListener is interpreted as the boolean capture
// value so we should only pass the `capture` property.
let $9aa32d02cdcaa670$var$eventOptionsSupported = false;
// Wrap into an IIFE because MS Edge <= v41 does not support having try/catch
// blocks right into the body of a module
(()=>{
    try {
        const options = {
            get capture () {
                $9aa32d02cdcaa670$var$eventOptionsSupported = true;
                return false;
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.addEventListener("test", options, options);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.removeEventListener("test", options, options);
    } catch (_e) {
    // event options not supported
    }
})();
class $9aa32d02cdcaa670$export$b28e368652651bd7 {
    setValue(value) {
        this.__pendingValue = value;
    }
    commit() {
        while((0, $2ba2127115d9c448$export$4b5d79f26e0e3ad5)(this.__pendingValue)){
            const directive = this.__pendingValue;
            this.__pendingValue = (0, $b4e7c8434a1b94a6$export$9c068ae9cc5db4e8);
            directive(this);
        }
        if (this.__pendingValue === (0, $b4e7c8434a1b94a6$export$9c068ae9cc5db4e8)) return;
        const newListener = this.__pendingValue;
        const oldListener = this.value;
        const shouldRemoveListener = newListener == null || oldListener != null && (newListener.capture !== oldListener.capture || newListener.once !== oldListener.once || newListener.passive !== oldListener.passive);
        const shouldAddListener = newListener != null && (oldListener == null || shouldRemoveListener);
        if (shouldRemoveListener) this.element.removeEventListener(this.eventName, this.__boundHandleEvent, this.__options);
        if (shouldAddListener) {
            this.__options = $9aa32d02cdcaa670$var$getOptions(newListener);
            this.element.addEventListener(this.eventName, this.__boundHandleEvent, this.__options);
        }
        this.value = newListener;
        this.__pendingValue = (0, $b4e7c8434a1b94a6$export$9c068ae9cc5db4e8);
    }
    handleEvent(event) {
        if (typeof this.value === "function") this.value.call(this.eventContext || this.element, event);
        else this.value.handleEvent(event);
    }
    constructor(element, eventName, eventContext){
        this.value = undefined;
        this.__pendingValue = undefined;
        this.element = element;
        this.eventName = eventName;
        this.eventContext = eventContext;
        this.__boundHandleEvent = (e)=>this.handleEvent(e);
    }
}
// We copy options because of the inconsistent behavior of browsers when reading
// the third argument of add/removeEventListener. IE11 doesn't support options
// at all. Chrome 41 only reads `capture` if the argument is an object.
const $9aa32d02cdcaa670$var$getOptions = (o)=>o && ($9aa32d02cdcaa670$var$eventOptionsSupported ? {
        capture: o.capture,
        passive: o.passive,
        once: o.once
    } : o.capture);


class $7a302afaca1933f9$export$53a556099f0fa088 {
    /**
     * Create parts for an attribute-position binding, given the event, attribute
     * name, and string literals.
     *
     * @param element The element containing the binding
     * @param name  The attribute name
     * @param strings The string literals. There are always at least two strings,
     *   event for fully-controlled bindings with a single expression.
     */ handleAttributeExpressions(element, name, strings, options) {
        const prefix = name[0];
        if (prefix === ".") {
            const committer = new (0, $9aa32d02cdcaa670$export$2d7935a96ad7cb22)(element, name.slice(1), strings);
            return committer.parts;
        }
        if (prefix === "@") return [
            new (0, $9aa32d02cdcaa670$export$b28e368652651bd7)(element, name.slice(1), options.eventContext)
        ];
        if (prefix === "?") return [
            new (0, $9aa32d02cdcaa670$export$b9df278b293d5b48)(element, name.slice(1), strings)
        ];
        const committer = new (0, $9aa32d02cdcaa670$export$9ac9216e336e96d0)(element, name, strings);
        return committer.parts;
    }
    /**
     * Create parts for a text-position binding.
     * @param templateFactory
     */ handleTextExpression(options) {
        return new (0, $9aa32d02cdcaa670$export$a354997aeda6e93)(options);
    }
}
const $7a302afaca1933f9$export$608256e8e6650f65 = new $7a302afaca1933f9$export$53a556099f0fa088();







/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ 

/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ 
function $15bdb7e702c2ea38$export$ac8809ff023de002(result) {
    let templateCache = $15bdb7e702c2ea38$export$f4a9a5e9f571ddee.get(result.type);
    if (templateCache === undefined) {
        templateCache = {
            stringsArray: new WeakMap(),
            keyString: new Map()
        };
        $15bdb7e702c2ea38$export$f4a9a5e9f571ddee.set(result.type, templateCache);
    }
    let template = templateCache.stringsArray.get(result.strings);
    if (template !== undefined) return template;
    // If the TemplateStringsArray is new, generate a key from the strings
    // This key is shared between all templates with identical content
    const key = result.strings.join((0, $1a9f99abf043bcce$export$ffc4d0086f1a4c9));
    // Check if we already have a Template for this key
    template = templateCache.keyString.get(key);
    if (template === undefined) {
        // If we have not seen this key before, create a new Template
        template = new (0, $1a9f99abf043bcce$export$14416b8d99d47caa)(result, result.getTemplateElement());
        // Cache the Template for this key
        templateCache.keyString.set(key, template);
    }
    // Cache all future queries for this TemplateStringsArray
    templateCache.stringsArray.set(result.strings, template);
    return template;
}
const $15bdb7e702c2ea38$export$f4a9a5e9f571ddee = new Map();


const $59bb141bad644030$export$6e2410c1d27f06e7 = new WeakMap();
const $59bb141bad644030$export$b3890eb0ae9dca99 = (result, container, options)=>{
    let part = $59bb141bad644030$export$6e2410c1d27f06e7.get(container);
    if (part === undefined) {
        (0, $d82f0725bc6518e6$export$77f49a256021c8de)(container, container.firstChild);
        $59bb141bad644030$export$6e2410c1d27f06e7.set(container, part = new (0, $9aa32d02cdcaa670$export$a354997aeda6e93)(Object.assign({
            templateFactory: $15bdb7e702c2ea38$export$ac8809ff023de002
        }, options)));
        part.appendInto(container);
    }
    part.setValue(result);
    part.commit();
};





// IMPORTANT: do not change the property name or the assignment expression.
// This line will be used in regexes to search for lit-html usage.
// TODO(justinfagnani): inject version number at build time
if (typeof window !== "undefined") (window["litHtmlVersions"] || (window["litHtmlVersions"] = [])).push("1.4.1");
const $da70b7db40529bd4$export$c0bb0b647f701bb5 = (strings, ...values)=>new (0, $763e43480b5302de$export$ce95ebd39b69fb27)(strings, values, "html", (0, $7a302afaca1933f9$export$608256e8e6650f65));
const $da70b7db40529bd4$export$7ed1367e7fa1ad68 = (strings, ...values)=>new (0, $763e43480b5302de$export$36e852975bbbeae0)(strings, values, "svg", (0, $7a302afaca1933f9$export$608256e8e6650f65));






let $81fcce2b1b834910$export$97aac956da55dae9;
let $81fcce2b1b834910$var$currentId = 0;
function $81fcce2b1b834910$export$5f80f094fd31fffd(state) {
    $81fcce2b1b834910$export$97aac956da55dae9 = state;
}
function $81fcce2b1b834910$export$42ffd38884aecdac() {
    $81fcce2b1b834910$export$97aac956da55dae9 = null;
    $81fcce2b1b834910$var$currentId = 0;
}
function $81fcce2b1b834910$export$5e14cdade93d6f7b() {
    return $81fcce2b1b834910$var$currentId++;
}


const $2f3be1cbff26ea5a$export$225ab0e0febd92b1 = Symbol("haunted.phase");
const $2f3be1cbff26ea5a$export$819a7f3d5f1d869d = Symbol("haunted.hook");
const $2f3be1cbff26ea5a$export$e3a0ce117547085d = Symbol("haunted.update");
const $2f3be1cbff26ea5a$export$c3840c26fe093fdb = Symbol("haunted.commit");
const $2f3be1cbff26ea5a$export$8e8d58c9b17fea3e = Symbol("haunted.effects");
const $2f3be1cbff26ea5a$export$db08efd2f456c5bf = Symbol("haunted.layoutEffects");
const $2f3be1cbff26ea5a$export$c1645e5fb9a50701 = "haunted.context";


let $28c7fbab1c97c142$var$_hookSymbol = (0, $2f3be1cbff26ea5a$export$819a7f3d5f1d869d), $28c7fbab1c97c142$var$_effectsSymbol = (0, $2f3be1cbff26ea5a$export$8e8d58c9b17fea3e), $28c7fbab1c97c142$var$_layoutEffectsSymbol = (0, $2f3be1cbff26ea5a$export$db08efd2f456c5bf);
class $28c7fbab1c97c142$export$7254cc27399e90bd {
    run(cb) {
        (0, $81fcce2b1b834910$export$5f80f094fd31fffd)(this);
        let res = cb();
        (0, $81fcce2b1b834910$export$42ffd38884aecdac)();
        return res;
    }
    _runEffects(phase) {
        let effects = this[phase];
        (0, $81fcce2b1b834910$export$5f80f094fd31fffd)(this);
        for (let effect of effects)effect.call(this);
        (0, $81fcce2b1b834910$export$42ffd38884aecdac)();
    }
    runEffects() {
        this._runEffects((0, $2f3be1cbff26ea5a$export$8e8d58c9b17fea3e));
    }
    runLayoutEffects() {
        this._runEffects((0, $2f3be1cbff26ea5a$export$db08efd2f456c5bf));
    }
    teardown() {
        let hooks = this[0, $2f3be1cbff26ea5a$export$819a7f3d5f1d869d];
        hooks.forEach((hook)=>{
            if (typeof hook.teardown === "function") hook.teardown();
        });
    }
    constructor(update, host){
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "update", void 0);
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "host", void 0);
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "virtual", void 0);
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, $28c7fbab1c97c142$var$_hookSymbol, void 0);
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, $28c7fbab1c97c142$var$_effectsSymbol, void 0);
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, $28c7fbab1c97c142$var$_layoutEffectsSymbol, void 0);
        this.update = update;
        this.host = host;
        this[0, $2f3be1cbff26ea5a$export$819a7f3d5f1d869d] = new Map();
        this[0, $2f3be1cbff26ea5a$export$8e8d58c9b17fea3e] = [];
        this[0, $2f3be1cbff26ea5a$export$db08efd2f456c5bf] = [];
    }
}



const $464fccaf2a972ce5$var$defer = Promise.resolve().then.bind(Promise.resolve());
function $464fccaf2a972ce5$var$runner() {
    let tasks = [];
    let id;
    function runTasks() {
        id = null;
        let t = tasks;
        tasks = [];
        for(var i = 0, len = t.length; i < len; i++)t[i]();
    }
    return function(task) {
        tasks.push(task);
        if (id == null) id = $464fccaf2a972ce5$var$defer(runTasks);
    };
}
const $464fccaf2a972ce5$var$read = $464fccaf2a972ce5$var$runner();
const $464fccaf2a972ce5$var$write = $464fccaf2a972ce5$var$runner();
let $464fccaf2a972ce5$var$_phaseSymbol = (0, $2f3be1cbff26ea5a$export$225ab0e0febd92b1);
class $464fccaf2a972ce5$export$61cd7faa6f3316a3 {
    update() {
        if (this._updateQueued) return;
        $464fccaf2a972ce5$var$read(()=>{
            let result = this.handlePhase((0, $2f3be1cbff26ea5a$export$e3a0ce117547085d));
            $464fccaf2a972ce5$var$write(()=>{
                this.handlePhase((0, $2f3be1cbff26ea5a$export$c3840c26fe093fdb), result);
                $464fccaf2a972ce5$var$write(()=>{
                    this.handlePhase((0, $2f3be1cbff26ea5a$export$8e8d58c9b17fea3e));
                });
            });
            this._updateQueued = false;
        });
        this._updateQueued = true;
    }
    handlePhase(phase, arg) {
        this[0, $2f3be1cbff26ea5a$export$225ab0e0febd92b1] = phase;
        switch(phase){
            case 0, $2f3be1cbff26ea5a$export$c3840c26fe093fdb:
                this.commit(arg);
                this.runEffects((0, $2f3be1cbff26ea5a$export$db08efd2f456c5bf));
                return;
            case 0, $2f3be1cbff26ea5a$export$e3a0ce117547085d:
                return this.render();
            case 0, $2f3be1cbff26ea5a$export$8e8d58c9b17fea3e:
                return this.runEffects((0, $2f3be1cbff26ea5a$export$8e8d58c9b17fea3e));
        }
    }
    render() {
        return this.state.run(()=>this.renderer.call(this.host, this.host));
    }
    runEffects(phase) {
        this.state._runEffects(phase);
    }
    teardown() {
        this.state.teardown();
    }
    constructor(renderer, host){
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "renderer", void 0);
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "host", void 0);
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "state", void 0);
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, $464fccaf2a972ce5$var$_phaseSymbol, void 0);
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "_updateQueued", void 0);
        this.renderer = renderer;
        this.host = host;
        this.state = new (0, $28c7fbab1c97c142$export$7254cc27399e90bd)(this.update.bind(this), host);
        this[0, $2f3be1cbff26ea5a$export$225ab0e0febd92b1] = null;
        this._updateQueued = false;
    }
}


const $98b764676e30b332$var$toCamelCase = (val = "")=>val.replace(/-+([a-z])?/g, (_, char)=>char ? char.toUpperCase() : "");
function $98b764676e30b332$export$3bc26eec1cc2439f(render) {
    class Scheduler extends (0, $464fccaf2a972ce5$export$61cd7faa6f3316a3) {
        commit(result) {
            render(result, this.frag);
        }
        constructor(renderer, frag, host){
            super(renderer, host || frag);
            (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "frag", void 0);
            this.frag = frag;
        }
    }
    function component(renderer, baseElementOrOptions, options) {
        const BaseElement = (options || baseElementOrOptions || {}).baseElement || HTMLElement;
        const { observedAttributes: observedAttributes = [], useShadowDOM: useShadowDOM = true, shadowRootInit: shadowRootInit = {} } = options || baseElementOrOptions || {};
        class Element extends BaseElement {
            static get observedAttributes() {
                return renderer.observedAttributes || observedAttributes || [];
            }
            connectedCallback() {
                this._scheduler.update();
            }
            disconnectedCallback() {
                this._scheduler.teardown();
            }
            attributeChangedCallback(name, oldValue, newValue) {
                if (oldValue === newValue) return;
                let val = newValue === "" ? true : newValue;
                Reflect.set(this, $98b764676e30b332$var$toCamelCase(name), val);
            }
            constructor(){
                super();
                (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "_scheduler", void 0);
                if (useShadowDOM === false) this._scheduler = new Scheduler(renderer, this);
                else {
                    this.attachShadow((0, $6bdeba009fe4f140$export$71511d61b312f219)({
                        mode: "open"
                    }, shadowRootInit));
                    this._scheduler = new Scheduler(renderer, this.shadowRoot, this);
                }
            }
        }
        function reflectiveProp(initialValue) {
            let value = initialValue;
            let isSetup = false;
            return Object.freeze({
                enumerable: true,
                configurable: true,
                get () {
                    return value;
                },
                set (newValue) {
                    // Avoid scheduling update when prop value hasn't changed
                    if (isSetup && value === newValue) return;
                    isSetup = true;
                    value = newValue;
                    if (this._scheduler) this._scheduler.update();
                }
            });
        }
        const proto = new Proxy(BaseElement.prototype, {
            getPrototypeOf (target) {
                return target;
            },
            set (target, key, value, receiver) {
                let desc;
                if (key in target) {
                    desc = Object.getOwnPropertyDescriptor(target, key);
                    if (desc && desc.set) {
                        desc.set.call(receiver, value);
                        return true;
                    }
                    Reflect.set(target, key, value, receiver);
                    return true;
                }
                if (typeof key === "symbol" || key[0] === "_") desc = {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: value
                };
                else desc = reflectiveProp(value);
                Object.defineProperty(receiver, key, desc);
                if (desc.set) desc.set.call(receiver, value);
                return true;
            }
        });
        Object.setPrototypeOf(Element.prototype, proto);
        return Element;
    }
    return component;
}








class $eeaa01b04d3aca9e$export$e594a57fbda5c090 {
    constructor(id, state){
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "id", void 0);
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "state", void 0);
        this.id = id;
        this.state = state;
    }
}
function $eeaa01b04d3aca9e$var$use(Hook, ...args) {
    let id = (0, $81fcce2b1b834910$export$5e14cdade93d6f7b)();
    let hooks = (0, $81fcce2b1b834910$export$97aac956da55dae9)[0, $2f3be1cbff26ea5a$export$819a7f3d5f1d869d];
    let hook = hooks.get(id);
    if (!hook) {
        hook = new Hook(id, (0, $81fcce2b1b834910$export$97aac956da55dae9), ...args);
        hooks.set(id, hook);
    }
    return hook.update(...args);
}
function $eeaa01b04d3aca9e$export$1062a250c78723ea(Hook) {
    return $eeaa01b04d3aca9e$var$use.bind(null, Hook);
}






function $c160505b16d9d975$export$7ea7134f704deda4(setEffects) {
    return (0, $eeaa01b04d3aca9e$export$1062a250c78723ea)(class extends (0, $eeaa01b04d3aca9e$export$e594a57fbda5c090) {
        update(callback, values) {
            this.callback = callback;
            this.values = values;
        }
        call() {
            if (!this.values || this.hasChanged()) this.run();
            this.lastValues = this.values;
        }
        run() {
            this.teardown();
            this._teardown = this.callback.call(this.state);
        }
        teardown() {
            if (typeof this._teardown === "function") this._teardown();
        }
        hasChanged() {
            return !this.lastValues || this.values.some((value, i)=>this.lastValues[i] !== value);
        }
        constructor(id, state, ignored1, ignored2){
            super(id, state);
            (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "callback", void 0);
            (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "lastValues", void 0);
            (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "values", void 0);
            (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "_teardown", void 0);
            setEffects(state, this);
        }
    });
}


function $f7659344dcec8608$export$2ff5f1970029d8ea(state, cb) {
    state[0, $2f3be1cbff26ea5a$export$8e8d58c9b17fea3e].push(cb);
}
/**
 * @function
 * @param {() => void} effect - callback function that runs each time dependencies change
 * @param {unknown[]} [dependencies] - list of dependencies to the effect
 * @return {void}
 */ const $f7659344dcec8608$export$6d9c69b0de29b591 = (0, $c160505b16d9d975$export$7ea7134f704deda4)($f7659344dcec8608$export$2ff5f1970029d8ea);


/**
 * @function
 * @template T
 * @param    {Context<T>} context
 * @return   {T}
 */ const $66d8f7a4d365186c$export$fae74005e78b1a27 = (0, $eeaa01b04d3aca9e$export$1062a250c78723ea)(class extends (0, $eeaa01b04d3aca9e$export$e594a57fbda5c090) {
    update(Context) {
        if (this.state.virtual) throw new Error("can't be used with virtual components");
        if (this.Context !== Context) {
            this._subscribe(Context);
            this.Context = Context;
        }
        return this.value;
    }
    call() {
        if (!this._ranEffect) {
            this._ranEffect = true;
            if (this._unsubscribe) this._unsubscribe();
            this._subscribe(this.Context);
            this.state.update();
        }
    }
    _updater(value) {
        this.value = value;
        this.state.update();
    }
    _subscribe(Context) {
        const detail = {
            Context: Context,
            callback: this._updater
        };
        this.state.host.dispatchEvent(new CustomEvent((0, $2f3be1cbff26ea5a$export$c1645e5fb9a50701), {
            detail: detail,
            bubbles: true,
            cancelable: true,
            composed: true
        }));
        const { unsubscribe: unsubscribe = null, value: value } = detail;
        this.value = unsubscribe ? value : Context.defaultValue;
        this._unsubscribe = unsubscribe;
    }
    teardown() {
        if (this._unsubscribe) this._unsubscribe();
    }
    constructor(id, state, _){
        super(id, state);
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "Context", void 0);
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "value", void 0);
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "_ranEffect", void 0);
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "_unsubscribe", void 0);
        this._updater = this._updater.bind(this);
        this._ranEffect = false;
        this._unsubscribe = null;
        (0, $f7659344dcec8608$export$2ff5f1970029d8ea)(state, this);
    }
});


function $dfe52d1026aa81e3$export$2d2e2a019c76af3(component) {
    return (defaultValue)=>{
        const Context = {
            Provider: class extends HTMLElement {
                disconnectedCallback() {
                    this.removeEventListener((0, $2f3be1cbff26ea5a$export$c1645e5fb9a50701), this);
                }
                handleEvent(event) {
                    const { detail: detail } = event;
                    if (detail.Context === Context) {
                        detail.value = this.value;
                        detail.unsubscribe = this.unsubscribe.bind(this, detail.callback);
                        this.listeners.add(detail.callback);
                        event.stopPropagation();
                    }
                }
                unsubscribe(callback) {
                    this.listeners.delete(callback);
                }
                set value(value) {
                    this._value = value;
                    for (let callback of this.listeners)callback(value);
                }
                get value() {
                    return this._value;
                }
                constructor(){
                    super();
                    (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "listeners", void 0);
                    (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "_value", void 0);
                    this.listeners = new Set();
                    this.addEventListener((0, $2f3be1cbff26ea5a$export$c1645e5fb9a50701), this);
                }
            },
            Consumer: component(function({ render: render }) {
                const context = (0, $66d8f7a4d365186c$export$fae74005e78b1a27)(Context);
                return render(context);
            }),
            defaultValue: defaultValue
        };
        return Context;
    };
}




/**
 * @function
 * @template T
 * @param  {() => T} fn function to memoize
 * @param  {unknown[]} values dependencies to the memoized computation
 * @return {T} The next computed value
 */ const $16de4c360f01f83a$export$1538c33de8887b59 = (0, $eeaa01b04d3aca9e$export$1062a250c78723ea)(class extends (0, $eeaa01b04d3aca9e$export$e594a57fbda5c090) {
    update(fn, values) {
        if (this.hasChanged(values)) {
            this.values = values;
            this.value = fn();
        }
        return this.value;
    }
    hasChanged(values = []) {
        return values.some((value, i)=>this.values[i] !== value);
    }
    constructor(id, state, fn, values){
        super(id, state);
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "value", void 0);
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "values", void 0);
        this.value = fn();
        this.values = values;
    }
});


/**
 * @function
 * @template {Function} T
 * @param    {T} fn - callback to memoize
 * @param    {unknown[]} inputs - dependencies to callback memoization
 * @return   {T}
 */ const $f46b1d44da689659$export$35808ee640e87ca7 = (fn, inputs)=>(0, $16de4c360f01f83a$export$1538c33de8887b59)(()=>fn, inputs);


/**
 * @license
 * Portions Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ 


function $a99df26d9da4c0f9$var$setLayoutEffects(state, cb) {
    state[0, $2f3be1cbff26ea5a$export$db08efd2f456c5bf].push(cb);
}
/**
 * @function
 * @param  {Effect} callback effecting callback
 * @param  {unknown[]} [values] dependencies to the effect
 * @return {void}
 */ const $a99df26d9da4c0f9$export$e5c5a5f917a5871c = (0, $c160505b16d9d975$export$7ea7134f704deda4)($a99df26d9da4c0f9$var$setLayoutEffects);




/**
 * @function
 * @template {*} T
 * @param {T} [initialState] - Optional initial state
 * @return {readonly [state: T, updaterFn: StateUpdater<T>]} stateTuple - Tuple of current state and state updater function
 */ const $5cdad80541da5d1a$export$60241385465d0a34 = (0, $eeaa01b04d3aca9e$export$1062a250c78723ea)(class extends (0, $eeaa01b04d3aca9e$export$e594a57fbda5c090) {
    update() {
        return this.args;
    }
    updater(value) {
        if (typeof value === "function") {
            const updaterFn = value;
            const [previousValue] = this.args;
            value = updaterFn(previousValue);
        }
        this.makeArgs(value);
        this.state.update();
    }
    makeArgs(value) {
        this.args = Object.freeze([
            value,
            this.updater
        ]);
    }
    constructor(id, state, initialValue){
        super(id, state);
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "args", void 0);
        this.updater = this.updater.bind(this);
        if (typeof initialValue === "function") initialValue = initialValue();
        this.makeArgs(initialValue);
    }
});


const $b5fff57cc60382b1$var$microtask = Promise.resolve();
/**
 * An implementation of ReactiveControllerHost that is driven by Haunted hooks
 * and `useController()`.
 */ class $b5fff57cc60382b1$var$HauntedControllerHost {
    addController(controller) {
        this._controllers.push(controller);
    }
    removeController(controller) {
        // Note, if the indexOf is -1, the >>> will flip the sign which makes the
        // splice do nothing.
        this._controllers && this._controllers.splice(this._controllers.indexOf(controller) >>> 0, 1);
    }
    requestUpdate() {
        if (!this._updatePending) {
            this._updatePending = true;
            $b5fff57cc60382b1$var$microtask.then(()=>this.kick(this.count + 1));
        }
    }
    get updateComplete() {
        return this._updateCompletePromise;
    }
    connected() {
        this._controllers.forEach((c)=>c.hostConnected && c.hostConnected());
    }
    disconnected() {
        this._controllers.forEach((c)=>c.hostDisconnected && c.hostDisconnected());
    }
    update() {
        this._controllers.forEach((c)=>c.hostUpdate && c.hostUpdate());
    }
    updated() {
        this._updatePending = false;
        const resolve = this._resolveUpdate;
        // Create a new updateComplete Promise for the next update,
        // before resolving the current one.
        this._updateCompletePromise = new Promise((res)=>{
            this._resolveUpdate = res;
        });
        this._controllers.forEach((c)=>c.hostUpdated && c.hostUpdated());
        resolve(this._updatePending);
    }
    constructor(count, kick){
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "count", void 0);
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "kick", void 0);
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "_controllers", []);
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "_updatePending", true);
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "_updateCompletePromise", void 0);
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "_resolveUpdate", void 0);
        this.count = count;
        this.kick = kick;
        this._updateCompletePromise = new Promise((res)=>{
            this._resolveUpdate = res;
        });
    }
}
function $b5fff57cc60382b1$export$e8c786024a2b0a79(createController) {
    const [count, kick] = (0, $5cdad80541da5d1a$export$60241385465d0a34)(0);
    const [host] = (0, $5cdad80541da5d1a$export$60241385465d0a34)(()=>{
        const host = new $b5fff57cc60382b1$var$HauntedControllerHost(count, kick);
        const controller = createController(host);
        host.primaryController = controller;
        host.connected();
        return host;
    });
    // We use useLayoutEffect because we need updated() called synchronously
    // after rendering.
    (0, $a99df26d9da4c0f9$export$e5c5a5f917a5871c)(()=>host.updated());
    // Returning a cleanup function simulates hostDisconnected timing. An empty
    // deps array tells Haunted to only call this once: on mount with the cleanup
    // called on unmount.
    (0, $a99df26d9da4c0f9$export$e5c5a5f917a5871c)(()=>()=>host.disconnected(), []);
    host.update();
    return host.primaryController;
}







/**
 * Given a reducer function, initial state, and optional state initializer function, returns a tuple of state and dispatch function.
 * @function
 * @template S State
 * @template I Initial State
 * @template A Action
 * @param {Reducer<S, A>} reducer - reducer function to compute the next state given the previous state and the action
 * @param {I} initialState - the initial state of the reducer
 * @param {(init: I) => S} [init=undefined] - Optional initializer function, called on initialState if provided
 * @return {readonly [S, (action: A) => void]}
 */ const $a0f52d8963ad5592$export$13e3392192263954 = (0, $eeaa01b04d3aca9e$export$1062a250c78723ea)(class extends (0, $eeaa01b04d3aca9e$export$e594a57fbda5c090) {
    update(reducer) {
        this.reducer = reducer;
        return [
            this.currentState,
            this.dispatch
        ];
    }
    dispatch(action) {
        this.currentState = this.reducer(this.currentState, action);
        this.state.update();
    }
    constructor(id, state, _, initialState, init){
        super(id, state);
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "reducer", void 0);
        (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "currentState", void 0);
        this.dispatch = this.dispatch.bind(this);
        this.currentState = init !== undefined ? init(initialState) : initialState;
    }
});





/**
 * @function
 * @template T
 * @param   {T} initialValue
 * @return  {{ current: T }} Ref
 */ const $7eebab23d02227ed$export$b8f5890fc79d6aca = (initialValue)=>(0, $16de4c360f01f83a$export$1538c33de8887b59)(()=>({
            current: initialValue
        }), []);





function $cc77b3258dd3820f$export$2e2bcd8739ae039({ render: render }) {
    const component = (0, $98b764676e30b332$export$3bc26eec1cc2439f)(render);
    const createContext = (0, $dfe52d1026aa81e3$export$2d2e2a019c76af3)(component);
    return {
        component: component,
        createContext: createContext
    };
}





const $00acf5dd646e098a$var$includes = Array.prototype.includes;
function $00acf5dd646e098a$export$3b9595dc33c67676() {
    const partToScheduler = new WeakMap();
    const schedulerToPart = new WeakMap();
    class Scheduler extends (0, $464fccaf2a972ce5$export$61cd7faa6f3316a3) {
        render() {
            return this.state.run(()=>this.renderer.apply(this.host, this.args));
        }
        commit(result) {
            this.host.setValue(result);
            this.host.commit();
        }
        teardown() {
            super.teardown();
            let part = schedulerToPart.get(this);
            partToScheduler.delete(part);
        }
        constructor(renderer, part){
            super(renderer, part);
            (0, $046ac80fccd9af81$export$71511d61b312f219)(this, "args", void 0);
            this.state.virtual = true;
        }
    }
    function virtual(renderer) {
        function factory(...args) {
            return (part)=>{
                let cont = partToScheduler.get(part);
                if (!cont) {
                    cont = new Scheduler(renderer, part);
                    partToScheduler.set(part, cont);
                    schedulerToPart.set(cont, part);
                    $00acf5dd646e098a$var$teardownOnRemove(cont, part);
                }
                cont.args = args;
                cont.update();
            };
        }
        return (0, $2ba2127115d9c448$export$99b43ad1ed32e735)(factory);
    }
    return virtual;
}
function $00acf5dd646e098a$var$teardownOnRemove(cont, part, node = part.startNode) {
    let frag = node.parentNode;
    let mo = new MutationObserver((mutations)=>{
        for (let mutation of mutations){
            if ($00acf5dd646e098a$var$includes.call(mutation.removedNodes, node)) {
                mo.disconnect();
                if (node.parentNode instanceof ShadowRoot) $00acf5dd646e098a$var$teardownOnRemove(cont, part);
                else cont.teardown();
                break;
            } else if ($00acf5dd646e098a$var$includes.call(mutation.addedNodes, node.nextSibling)) {
                mo.disconnect();
                $00acf5dd646e098a$var$teardownOnRemove(cont, part, node.nextSibling || undefined);
                break;
            }
        }
    });
    mo.observe(frag, {
        childList: true
    });
}


const { component: $4e8e25f2759d26d8$export$d8556a2a8f973135, createContext: $4e8e25f2759d26d8$export$fd42f52fd3ae1109 } = (0, $cc77b3258dd3820f$export$2e2bcd8739ae039)({
    render: $59bb141bad644030$export$b3890eb0ae9dca99
});
const $4e8e25f2759d26d8$export$e193c227f15db60d = (0, $00acf5dd646e098a$export$3b9595dc33c67676)();





var $7a8bedae7ee068a0$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $7a8bedae7ee068a0$var$INFINITY = 1 / 0, $7a8bedae7ee068a0$var$MAX_INTEGER = 1.7976931348623157e+308, $7a8bedae7ee068a0$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $7a8bedae7ee068a0$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $7a8bedae7ee068a0$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $7a8bedae7ee068a0$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $7a8bedae7ee068a0$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $7a8bedae7ee068a0$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $7a8bedae7ee068a0$var$freeParseInt = parseInt;
/** Used for built-in method references. */ var $7a8bedae7ee068a0$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $7a8bedae7ee068a0$var$objectToString = $7a8bedae7ee068a0$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7a8bedae7ee068a0$var$nativeMax = Math.max, $7a8bedae7ee068a0$var$nativeMin = Math.min;
/**
 * The base implementation of `_.inRange` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to check.
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 */ function $7a8bedae7ee068a0$var$baseInRange(number, start, end) {
    return number >= $7a8bedae7ee068a0$var$nativeMin(start, end) && number < $7a8bedae7ee068a0$var$nativeMax(start, end);
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $7a8bedae7ee068a0$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $7a8bedae7ee068a0$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $7a8bedae7ee068a0$var$isSymbol(value) {
    return typeof value == "symbol" || $7a8bedae7ee068a0$var$isObjectLike(value) && $7a8bedae7ee068a0$var$objectToString.call(value) == $7a8bedae7ee068a0$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $7a8bedae7ee068a0$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $7a8bedae7ee068a0$var$toNumber(value);
    if (value === $7a8bedae7ee068a0$var$INFINITY || value === -$7a8bedae7ee068a0$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $7a8bedae7ee068a0$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $7a8bedae7ee068a0$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($7a8bedae7ee068a0$var$isSymbol(value)) return $7a8bedae7ee068a0$var$NAN;
    if ($7a8bedae7ee068a0$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $7a8bedae7ee068a0$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($7a8bedae7ee068a0$var$reTrim, "");
    var isBinary = $7a8bedae7ee068a0$var$reIsBinary.test(value);
    return isBinary || $7a8bedae7ee068a0$var$reIsOctal.test(value) ? $7a8bedae7ee068a0$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $7a8bedae7ee068a0$var$reIsBadHex.test(value) ? $7a8bedae7ee068a0$var$NAN : +value;
}
/**
 * Checks if `n` is between `start` and up to, but not including, `end`. If
 * `end` is not specified, it's set to `start` with `start` then set to `0`.
 * If `start` is greater than `end` the params are swapped to support
 * negative ranges.
 *
 * @static
 * @memberOf _
 * @since 3.3.0
 * @category Number
 * @param {number} number The number to check.
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 * @see _.range, _.rangeRight
 * @example
 *
 * _.inRange(3, 2, 4);
 * // => true
 *
 * _.inRange(4, 8);
 * // => true
 *
 * _.inRange(4, 2);
 * // => false
 *
 * _.inRange(2, 2);
 * // => false
 *
 * _.inRange(1.2, 2);
 * // => true
 *
 * _.inRange(5.2, 4);
 * // => false
 *
 * _.inRange(-3, -2, -6);
 * // => true
 */ function $7a8bedae7ee068a0$var$inRange(number, start, end) {
    start = $7a8bedae7ee068a0$var$toFinite(start);
    if (end === undefined) {
        end = start;
        start = 0;
    } else end = $7a8bedae7ee068a0$var$toFinite(end);
    number = $7a8bedae7ee068a0$var$toNumber(number);
    return $7a8bedae7ee068a0$var$baseInRange(number, start, end);
}
$7a8bedae7ee068a0$exports = $7a8bedae7ee068a0$var$inRange;



var $nmac8 = parcelRequire("nmac8");

const $a3a83d550ecd5f0d$export$d62335b9c14fe5c1 = [
    "17\u5C81\u53CA\u4EE5\u4E0B",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45\u5C81\u53CA\u4EE5\u4E0A"
];
const $a3a83d550ecd5f0d$export$f70d1c980b93cf1b = [
    [
        18,
        99
    ],
    [
        19,
        105
    ],
    [
        20,
        110
    ],
    [
        21,
        110
    ],
    [
        22,
        110
    ],
    [
        23,
        110
    ],
    [
        24,
        110
    ],
    [
        25,
        110
    ],
    [
        26,
        110
    ],
    [
        27,
        110
    ],
    [
        28,
        110
    ],
    [
        29,
        110
    ],
    [
        30,
        105
    ],
    [
        31,
        99
    ],
    [
        32,
        94
    ],
    [
        33,
        88
    ],
    [
        34,
        83
    ],
    [
        35,
        77
    ],
    [
        36,
        72
    ],
    [
        37,
        66
    ],
    [
        38,
        61
    ],
    [
        39,
        55
    ],
    [
        40,
        50
    ],
    [
        41,
        39
    ],
    [
        42,
        28
    ],
    [
        43,
        17
    ],
    [
        44,
        6
    ]
];
const $a3a83d550ecd5f0d$export$7db9f6207b5def67 = [
    [
        18,
        90
    ],
    [
        19,
        95
    ],
    [
        20,
        100
    ],
    [
        21,
        100
    ],
    [
        22,
        100
    ],
    [
        23,
        100
    ],
    [
        24,
        100
    ],
    [
        25,
        100
    ],
    [
        26,
        100
    ],
    [
        27,
        100
    ],
    [
        28,
        100
    ],
    [
        29,
        100
    ],
    [
        30,
        95
    ],
    [
        31,
        90
    ],
    [
        32,
        85
    ],
    [
        33,
        80
    ],
    [
        34,
        75
    ],
    [
        35,
        70
    ],
    [
        36,
        65
    ],
    [
        37,
        60
    ],
    [
        38,
        55
    ],
    [
        39,
        50
    ],
    [
        40,
        45
    ],
    [
        41,
        35
    ],
    [
        42,
        25
    ],
    [
        43,
        15
    ],
    [
        44,
        5
    ]
];
const $a3a83d550ecd5f0d$export$4d6163d904b950e2 = [
    "\u9AD8\u4E2D\u4EE5\u4E0B",
    "\u9AD8\u4E2D",
    "1\u5E74\u5927\u4E13",
    "2\u5E74\u5927\u4E13",
    "3\u5E74\u4EE5\u4E0A\u5927\u4E13\u6216\u672C\u79D1",
    "\u53CC\u4E13\u4E1A\uFF083\u5E74\u4EE5\u4E0A+1\u5E74\u4EE5\u4E0A\uFF09",
    "\u7855\u58EB\u5B66\u4F4D\u6216\u4E13\u4E1A\u5B66\u4F4D\uFF08\u5982\u533B\u5B66\uFF09",
    "\u535A\u58EB\u5B66\u4F4D"
];
const $a3a83d550ecd5f0d$export$65e0517ca9b12a45 = [
    [
        $a3a83d550ecd5f0d$export$4d6163d904b950e2[0],
        0
    ],
    [
        $a3a83d550ecd5f0d$export$4d6163d904b950e2[1],
        30
    ],
    [
        $a3a83d550ecd5f0d$export$4d6163d904b950e2[2],
        90
    ],
    [
        $a3a83d550ecd5f0d$export$4d6163d904b950e2[3],
        98
    ],
    [
        $a3a83d550ecd5f0d$export$4d6163d904b950e2[4],
        120
    ],
    [
        $a3a83d550ecd5f0d$export$4d6163d904b950e2[5],
        128
    ],
    [
        $a3a83d550ecd5f0d$export$4d6163d904b950e2[6],
        135
    ],
    [
        $a3a83d550ecd5f0d$export$4d6163d904b950e2[7],
        150
    ]
];
const $a3a83d550ecd5f0d$export$f30bc00524f41653 = [
    [
        $a3a83d550ecd5f0d$export$4d6163d904b950e2[0],
        0
    ],
    [
        $a3a83d550ecd5f0d$export$4d6163d904b950e2[1],
        28
    ],
    [
        $a3a83d550ecd5f0d$export$4d6163d904b950e2[2],
        84
    ],
    [
        $a3a83d550ecd5f0d$export$4d6163d904b950e2[3],
        91
    ],
    [
        $a3a83d550ecd5f0d$export$4d6163d904b950e2[4],
        112
    ],
    [
        $a3a83d550ecd5f0d$export$4d6163d904b950e2[5],
        119
    ],
    [
        $a3a83d550ecd5f0d$export$4d6163d904b950e2[6],
        126
    ],
    [
        $a3a83d550ecd5f0d$export$4d6163d904b950e2[7],
        140
    ]
];
const $a3a83d550ecd5f0d$export$4f7401b47f380363 = [
    [
        $a3a83d550ecd5f0d$export$4d6163d904b950e2[0],
        0
    ],
    [
        $a3a83d550ecd5f0d$export$4d6163d904b950e2[1],
        2
    ],
    [
        $a3a83d550ecd5f0d$export$4d6163d904b950e2[2],
        6
    ],
    [
        $a3a83d550ecd5f0d$export$4d6163d904b950e2[3],
        7
    ],
    [
        $a3a83d550ecd5f0d$export$4d6163d904b950e2[4],
        8
    ],
    [
        $a3a83d550ecd5f0d$export$4d6163d904b950e2[5],
        9
    ],
    [
        $a3a83d550ecd5f0d$export$4d6163d904b950e2[6],
        10
    ],
    [
        $a3a83d550ecd5f0d$export$4d6163d904b950e2[7],
        10
    ]
];
const $a3a83d550ecd5f0d$export$1307a0470afc0a99 = [
    [
        0,
        "0-1\u5E74\u4EE5\u4E0B"
    ],
    [
        1,
        "1-2\u5E74\u4EE5\u4E0B"
    ],
    [
        2,
        "2-3\u5E74\u4EE5\u4E0B"
    ],
    [
        3,
        "3-4\u5E74\u4EE5\u4E0B"
    ],
    [
        4,
        "4-5\u5E74\u4EE5\u4E0B"
    ],
    [
        5,
        "5\u5E74\u4EE5\u4E0A"
    ]
];
const $a3a83d550ecd5f0d$export$cf1ea28d35622845 = [
    [
        0,
        "0-1\u5E74\u4EE5\u4E0B"
    ],
    [
        1,
        "1-3\u5E74\u4EE5\u4E0B"
    ],
    [
        3,
        "3\u5E74\u4EE5\u4E0A"
    ]
];
const $a3a83d550ecd5f0d$export$ff5a5eabd004a88f = [
    "\u6211\u670900\u7C7B\u7684\u96C7\u4E3B\u62C5\u4FDD",
    "\u6211\u6709\u5176\u4ED6\u7C7B\u7684\u96C7\u4E3B\u62C5\u4FDD",
    "\u6CA1\u6709\u96C7\u4E3B\u62C5\u4FDD"
];
const $a3a83d550ecd5f0d$export$68dbab1836f00a90 = [
    [
        $a3a83d550ecd5f0d$export$ff5a5eabd004a88f[0],
        200
    ],
    [
        $a3a83d550ecd5f0d$export$ff5a5eabd004a88f[1],
        50
    ],
    [
        $a3a83d550ecd5f0d$export$ff5a5eabd004a88f[2],
        0
    ]
];
const $a3a83d550ecd5f0d$export$1a569da8b8981cce = [
    "\u6211\u6709\u5B66\u52363\u5E74\u4EE5\u4E0A\u7684\u52A0\u62FF\u5927\u5B66\u5386\uFF0C\u6216\u8005\u52A0\u62FF\u5927\u7684\u7855\u58EB\u3001\u535A\u58EB\u5B66\u5386",
    "\u6211\u6709\u5B66\u52361-2\u5E74\u7684\u7684\u52A0\u62FF\u5927\u5B66\u5386",
    "\u6CA1\u6709\u4E0A\u8FF0\u5B66\u5386"
];
const $a3a83d550ecd5f0d$export$d2702c1a8faa626a = [
    [
        $a3a83d550ecd5f0d$export$1a569da8b8981cce[0],
        30
    ],
    [
        $a3a83d550ecd5f0d$export$1a569da8b8981cce[1],
        15
    ],
    [
        $a3a83d550ecd5f0d$export$1a569da8b8981cce[2],
        0
    ]
];
const $a3a83d550ecd5f0d$export$5fbea886f7806b1b = 15;
const $a3a83d550ecd5f0d$export$96bf579af963ed26 = 600;
const $a3a83d550ecd5f0d$export$2bbd7e634e09d83e = {
    listen: [
        0,
        9
    ],
    speak: [
        0,
        9
    ],
    read: [
        0,
        9
    ],
    write: [
        0,
        9
    ]
};
const $a3a83d550ecd5f0d$export$dc628681ec880030 = {
    listen: [
        0,
        10
    ],
    speak: [
        0,
        10
    ],
    read: [
        0,
        10
    ],
    write: [
        0,
        10
    ]
};
const $a3a83d550ecd5f0d$export$9db991b8c8f4570a = {
    listen: [
        0,
        360
    ],
    speak: [
        0,
        450
    ],
    read: [
        0,
        300
    ],
    write: [
        0,
        450
    ]
};
const $a3a83d550ecd5f0d$export$bc17d7979e96c381 = {
    listen: [
        0,
        699
    ],
    speak: [
        0,
        20
    ],
    read: [
        0,
        699
    ],
    write: [
        0,
        20
    ]
};
const $a3a83d550ecd5f0d$export$274e2e0d8f2288c4 = [
    [
        4,
        6
    ],
    [
        5,
        6
    ],
    [
        6,
        9
    ],
    [
        7,
        17
    ],
    [
        8,
        23
    ],
    [
        9,
        31
    ],
    [
        10,
        34
    ]
];
const $a3a83d550ecd5f0d$export$9198ad443631abbf = [
    [
        4,
        6
    ],
    [
        5,
        6
    ],
    [
        6,
        8
    ],
    [
        7,
        16
    ],
    [
        8,
        22
    ],
    [
        9,
        29
    ],
    [
        10,
        32
    ]
];
const $a3a83d550ecd5f0d$export$c965ff5642f98911 = [
    [
        5,
        1
    ],
    [
        6,
        1
    ],
    [
        7,
        3
    ],
    [
        8,
        3
    ],
    [
        9,
        6
    ],
    [
        10,
        6
    ]
];
const $a3a83d550ecd5f0d$export$689d72a921053d50 = [
    [
        5,
        1
    ],
    [
        6,
        1
    ],
    [
        7,
        3
    ],
    [
        8,
        3
    ],
    [
        9,
        5
    ],
    [
        10,
        5
    ]
];
const $a3a83d550ecd5f0d$export$e6beec7f45e4779b = [
    [
        1,
        40
    ],
    [
        2,
        53
    ],
    [
        3,
        64
    ],
    [
        4,
        72
    ],
    [
        5,
        80
    ]
];
const $a3a83d550ecd5f0d$export$e67cb4be0ee021d1 = [
    [
        1,
        35
    ],
    [
        2,
        46
    ],
    [
        3,
        56
    ],
    [
        4,
        63
    ],
    [
        5,
        70
    ]
];
const $a3a83d550ecd5f0d$export$3ebe670b4d690f8d = [
    [
        1,
        5
    ],
    [
        2,
        7
    ],
    [
        3,
        8
    ],
    [
        4,
        9
    ],
    [
        5,
        10
    ]
];
const $a3a83d550ecd5f0d$export$9166a57ad091bff8 = [
    [
        0,
        0
    ],
    [
        1,
        13
    ],
    [
        2,
        25
    ],
    [
        3,
        -1
    ],
    [
        4,
        50
    ]
];
const $a3a83d550ecd5f0d$export$8c9d8ffc736b3e6c = [
    [
        0,
        0
    ],
    [
        1,
        13
    ],
    [
        2,
        25
    ],
    [
        3,
        -1
    ],
    [
        4,
        50
    ]
];
const $a3a83d550ecd5f0d$export$be16cf434455d79f = [
    [
        0,
        0
    ],
    [
        1,
        25
    ],
    [
        2,
        50
    ]
];
const $a3a83d550ecd5f0d$export$7d1a62c422ad3a6b = [
    [
        0,
        0
    ],
    [
        1,
        25
    ],
    [
        2,
        50
    ]
];
const $a3a83d550ecd5f0d$export$a161b1198dd9cbf0 = [
    "\u96C5\u601D\u57F9\u8BAD\u7C7B\uFF08IELTS G\u7C7B\uFF09",
    "\u601D\u57F9\uFF08CELPIP\uFF09",
    "TEF",
    "TCF"
];
const $a3a83d550ecd5f0d$export$a1e00d3d088e80f7 = [
    $a3a83d550ecd5f0d$export$a161b1198dd9cbf0[0],
    $a3a83d550ecd5f0d$export$a161b1198dd9cbf0[1]
];
const $a3a83d550ecd5f0d$export$1034dbf5e1792b92 = [
    $a3a83d550ecd5f0d$export$a161b1198dd9cbf0[2],
    $a3a83d550ecd5f0d$export$a161b1198dd9cbf0[3]
];
const $a3a83d550ecd5f0d$export$c06f55024bb06ed4 = [
    "\u542C",
    "\u8BF4",
    "\u8BFB",
    "\u5199"
];
const $a3a83d550ecd5f0d$export$30c56fe24ead1f01 = {
    [$a3a83d550ecd5f0d$export$a161b1198dd9cbf0[0]]: {
        [$a3a83d550ecd5f0d$export$c06f55024bb06ed4[0]]: [
            [
                0,
                1
            ],
            [
                1,
                2
            ],
            [
                2,
                3.5
            ],
            [
                3.5,
                4.5
            ],
            [
                4.5,
                5
            ],
            [
                5,
                5.5
            ],
            [
                5.5,
                6
            ],
            [
                6,
                7.5
            ],
            [
                7.5,
                8
            ],
            [
                8,
                8.5
            ],
            [
                8.5,
                9.001
            ]
        ],
        [$a3a83d550ecd5f0d$export$c06f55024bb06ed4[1]]: [
            [
                0,
                1
            ],
            [
                1,
                2
            ],
            [
                2,
                3
            ],
            [
                3,
                4
            ],
            [
                4,
                5
            ],
            [
                5,
                5.5
            ],
            [
                5.5,
                6
            ],
            [
                6,
                6.5
            ],
            [
                6.5,
                7
            ],
            [
                7,
                7.5
            ],
            [
                7.5,
                9.001
            ]
        ],
        [$a3a83d550ecd5f0d$export$c06f55024bb06ed4[2]]: [
            [
                0,
                1
            ],
            [
                1,
                1.5
            ],
            [
                1.5,
                2.5
            ],
            [
                2.5,
                3.5
            ],
            [
                3.5,
                4.5
            ],
            [
                4.5,
                5
            ],
            [
                5,
                6
            ],
            [
                6,
                6.5
            ],
            [
                6.5,
                7
            ],
            [
                7,
                8
            ],
            [
                8,
                9.001
            ]
        ],
        [$a3a83d550ecd5f0d$export$c06f55024bb06ed4[3]]: [
            [
                0,
                1
            ],
            [
                1,
                2
            ],
            [
                2,
                3
            ],
            [
                3,
                4
            ],
            [
                4,
                5
            ],
            [
                5,
                5.5
            ],
            [
                5.5,
                6
            ],
            [
                6,
                6.5
            ],
            [
                6.5,
                7
            ],
            [
                7,
                7.5
            ],
            [
                7.5,
                9.001
            ]
        ]
    },
    [$a3a83d550ecd5f0d$export$a161b1198dd9cbf0[1]]: {
        [$a3a83d550ecd5f0d$export$c06f55024bb06ed4[0]]: [
            [
                0,
                1
            ],
            [
                1,
                2
            ],
            [
                2,
                3
            ],
            [
                3,
                4
            ],
            [
                4,
                5
            ],
            [
                5,
                6
            ],
            [
                6,
                7
            ],
            [
                7,
                8
            ],
            [
                8,
                9
            ],
            [
                9,
                10
            ],
            [
                10,
                10.001
            ]
        ],
        [$a3a83d550ecd5f0d$export$c06f55024bb06ed4[1]]: [
            [
                0,
                1
            ],
            [
                1,
                2
            ],
            [
                2,
                3
            ],
            [
                3,
                4
            ],
            [
                4,
                5
            ],
            [
                5,
                6
            ],
            [
                6,
                7
            ],
            [
                7,
                8
            ],
            [
                8,
                9
            ],
            [
                9,
                10
            ],
            [
                10,
                10.001
            ]
        ],
        [$a3a83d550ecd5f0d$export$c06f55024bb06ed4[2]]: [
            [
                0,
                1
            ],
            [
                1,
                2
            ],
            [
                2,
                3
            ],
            [
                3,
                4
            ],
            [
                4,
                5
            ],
            [
                5,
                6
            ],
            [
                6,
                7
            ],
            [
                7,
                8
            ],
            [
                8,
                9
            ],
            [
                9,
                10
            ],
            [
                10,
                10.001
            ]
        ],
        [$a3a83d550ecd5f0d$export$c06f55024bb06ed4[3]]: [
            [
                0,
                1
            ],
            [
                1,
                2
            ],
            [
                2,
                3
            ],
            [
                3,
                4
            ],
            [
                4,
                5
            ],
            [
                5,
                6
            ],
            [
                6,
                7
            ],
            [
                7,
                8
            ],
            [
                8,
                9
            ],
            [
                9,
                10
            ],
            [
                10,
                10.001
            ]
        ]
    },
    [$a3a83d550ecd5f0d$export$a161b1198dd9cbf0[2]]: {
        [$a3a83d550ecd5f0d$export$c06f55024bb06ed4[0]]: [
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                145
            ],
            [
                145,
                181
            ],
            [
                181,
                217
            ],
            [
                217,
                249
            ],
            [
                249,
                280
            ],
            [
                280,
                298
            ],
            [
                298,
                316
            ],
            [
                316,
                360.001
            ]
        ],
        [$a3a83d550ecd5f0d$export$c06f55024bb06ed4[1]]: [
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                181
            ],
            [
                181,
                226
            ],
            [
                226,
                271
            ],
            [
                271,
                310
            ],
            [
                310,
                349
            ],
            [
                349,
                371
            ],
            [
                371,
                393
            ],
            [
                393,
                450.001
            ]
        ],
        [$a3a83d550ecd5f0d$export$c06f55024bb06ed4[2]]: [
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                121
            ],
            [
                121,
                151
            ],
            [
                151,
                181
            ],
            [
                181,
                207
            ],
            [
                207,
                233
            ],
            [
                233,
                248
            ],
            [
                248,
                263
            ],
            [
                263,
                300.001
            ]
        ],
        [$a3a83d550ecd5f0d$export$c06f55024bb06ed4[3]]: [
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                181
            ],
            [
                181,
                226
            ],
            [
                226,
                271
            ],
            [
                271,
                310
            ],
            [
                310,
                349
            ],
            [
                349,
                371
            ],
            [
                371,
                393
            ],
            [
                393,
                450.001
            ]
        ]
    },
    [$a3a83d550ecd5f0d$export$a161b1198dd9cbf0[3]]: {
        [$a3a83d550ecd5f0d$export$c06f55024bb06ed4[0]]: [
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                331
            ],
            [
                331,
                369
            ],
            [
                369,
                398
            ],
            [
                398,
                458
            ],
            [
                458,
                503
            ],
            [
                503,
                523
            ],
            [
                523,
                549
            ],
            [
                549,
                699.001
            ]
        ],
        [$a3a83d550ecd5f0d$export$c06f55024bb06ed4[1]]: [
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                4
            ],
            [
                4,
                6
            ],
            [
                6,
                7
            ],
            [
                7,
                10
            ],
            [
                10,
                12
            ],
            [
                12,
                14
            ],
            [
                14,
                16
            ],
            [
                16,
                20.001
            ]
        ],
        [$a3a83d550ecd5f0d$export$c06f55024bb06ed4[2]]: [
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                342
            ],
            [
                342,
                375
            ],
            [
                375,
                406
            ],
            [
                406,
                453
            ],
            [
                453,
                499
            ],
            [
                499,
                524
            ],
            [
                524,
                549
            ],
            [
                549,
                699.001
            ]
        ],
        [$a3a83d550ecd5f0d$export$c06f55024bb06ed4[3]]: [
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                4
            ],
            [
                4,
                6
            ],
            [
                6,
                7
            ],
            [
                7,
                10
            ],
            [
                10,
                12
            ],
            [
                12,
                14
            ],
            [
                14,
                16
            ],
            [
                16,
                20.001
            ]
        ]
    }
};


let $6a559403926e01b7$var$_ = (t)=>t, $6a559403926e01b7$var$t;
const $6a559403926e01b7$export$6e4aeae4b932ab52 = (rawScore, testType, testSubject)=>{
    console.log((0, $a3a83d550ecd5f0d$export$30c56fe24ead1f01));
    let clb = 0;
    let score = Number(rawScore);
    if (Number.isNaN(score)) return 0;
    if (!(0, $a3a83d550ecd5f0d$export$a161b1198dd9cbf0).find((type)=>type === testType)) return 0;
    if (!(0, $a3a83d550ecd5f0d$export$c06f55024bb06ed4).find((subject)=>subject === testSubject)) return 0;
    if ((0, $a3a83d550ecd5f0d$export$30c56fe24ead1f01)[testType] && (0, $a3a83d550ecd5f0d$export$30c56fe24ead1f01)[testType][testSubject]) {
        const testClbRelations = (0, $a3a83d550ecd5f0d$export$30c56fe24ead1f01)[testType][testSubject];
        if (testClbRelations.findIndex((range)=>(0, (/*@__PURE__*/$parcel$interopDefault($7a8bedae7ee068a0$exports)))(score, ...range)) !== -1) clb = testClbRelations.findIndex((range)=>(0, (/*@__PURE__*/$parcel$interopDefault($7a8bedae7ee068a0$exports)))(score, ...range));
    }
    return clb;
};
const $6a559403926e01b7$export$a2af4d04d4184fe2 = (rawAge, isSingle = true)=>{
    const age = Number(rawAge);
    if (Number.isNaN(age) || age < 0) return 0;
    let score = 0;
    if (isSingle && (0, $a3a83d550ecd5f0d$export$f70d1c980b93cf1b).find((ageScorePair)=>ageScorePair[0] === age)) score = (0, $a3a83d550ecd5f0d$export$f70d1c980b93cf1b).find((ageScorePair)=>ageScorePair[0] === age)[1];
    if (!isSingle && (0, $a3a83d550ecd5f0d$export$7db9f6207b5def67).find((ageScorePair)=>ageScorePair[0] === age)) score = (0, $a3a83d550ecd5f0d$export$7db9f6207b5def67).find((ageScorePair)=>ageScorePair[0] === age)[1];
    return score;
};
const $6a559403926e01b7$export$231d4b88776bb861 = (eduLevel, isSingle = true, isSpouse = false)=>{
    if (!(0, $a3a83d550ecd5f0d$export$4d6163d904b950e2).find((level)=>level === eduLevel)) return 0;
    let score = 0;
    if (isSingle && (0, $a3a83d550ecd5f0d$export$65e0517ca9b12a45).find((eduScorePair)=>eduScorePair[0] === eduLevel)) score = (0, $a3a83d550ecd5f0d$export$65e0517ca9b12a45).find((eduScorePair)=>eduScorePair[0] === eduLevel)[1];
    if (!isSingle && !isSpouse && (0, $a3a83d550ecd5f0d$export$f30bc00524f41653).find((eduScorePair)=>eduScorePair[0] === eduLevel)) score = (0, $a3a83d550ecd5f0d$export$f30bc00524f41653).find((eduScorePair)=>eduScorePair[0] === eduLevel)[1];
    if (!isSingle && isSpouse && (0, $a3a83d550ecd5f0d$export$4f7401b47f380363).find((eduScorePair)=>eduScorePair[0] === eduLevel)) score = (0, $a3a83d550ecd5f0d$export$4f7401b47f380363).find((eduScorePair)=>eduScorePair[0] === eduLevel)[1];
    return score;
};
const $6a559403926e01b7$export$3a0e8dc9544a08b = (rawClb, isSingle = true, isSpouse = false, isFirst = true)=>{
    const clb = Number(rawClb);
    if (Number.isNaN(clb) || clb > 10 || clb < 0) return 0;
    let score = 0;
    if (isSingle && isFirst && (0, $a3a83d550ecd5f0d$export$274e2e0d8f2288c4).find((lanScorePair)=>lanScorePair[0] === clb)) score = (0, $a3a83d550ecd5f0d$export$274e2e0d8f2288c4).find((lanScorePair)=>lanScorePair[0] === clb)[1];
    if (!isSingle && isFirst && (0, $a3a83d550ecd5f0d$export$9198ad443631abbf).find((lanScorePair)=>lanScorePair[0] === clb)) score = (0, $a3a83d550ecd5f0d$export$9198ad443631abbf).find((lanScorePair)=>lanScorePair[0] === clb)[1];
    if (!isFirst && !isSpouse && (0, $a3a83d550ecd5f0d$export$c965ff5642f98911).find((lanScorePair)=>lanScorePair[0] === clb)) score = (0, $a3a83d550ecd5f0d$export$c965ff5642f98911).find((lanScorePair)=>lanScorePair[0] === clb)[1];
    if (!isSingle && isSpouse && (0, $a3a83d550ecd5f0d$export$689d72a921053d50).find((lanScorePair)=>lanScorePair[0] === clb)) score = (0, $a3a83d550ecd5f0d$export$689d72a921053d50).find((lanScorePair)=>lanScorePair[0] === clb)[1];
    return score;
};
const $6a559403926e01b7$export$12b9b47f34fd261 = (testInfo, isSingle = true, isSpouse = false, isFirst = true)=>{
    let score = 0;
    Object.keys(testInfo).forEach((testSubject)=>{
        score += testInfo[testSubject].score;
    });
    if (!isSingle && !isSpouse && !isFirst) score = Math.min(22, score);
    return score;
};
const $6a559403926e01b7$export$4d121d8ff4b62f32 = (rawExp, isSingle = true, isSpouse = false)=>{
    let exp = Number(rawExp);
    if (Number.isNaN(exp) || exp < 1) return 0;
    let score = 0;
    if (isSingle) {
        let maxKey = (0, (/*@__PURE__*/$parcel$interopDefault($nmac8)))((0, $a3a83d550ecd5f0d$export$e6beec7f45e4779b), (expScorePair)=>expScorePair[0])[0];
        exp = Math.min(maxKey, exp);
        if ((0, $a3a83d550ecd5f0d$export$e6beec7f45e4779b).find((expScorePair)=>expScorePair[0] === exp)) score = (0, $a3a83d550ecd5f0d$export$e6beec7f45e4779b).find((expScorePair)=>expScorePair[0] === exp)[1];
    }
    if (!isSingle && !isSpouse) {
        let maxKey = (0, (/*@__PURE__*/$parcel$interopDefault($nmac8)))((0, $a3a83d550ecd5f0d$export$e67cb4be0ee021d1), (expScorePair)=>expScorePair[0])[0];
        exp = Math.min(maxKey, exp);
        if ((0, $a3a83d550ecd5f0d$export$e67cb4be0ee021d1).find((expScorePair)=>expScorePair[0] === exp)) score = (0, $a3a83d550ecd5f0d$export$e67cb4be0ee021d1).find((expScorePair)=>expScorePair[0] === exp)[1];
    }
    if (!isSingle && isSpouse) {
        let maxKey = (0, (/*@__PURE__*/$parcel$interopDefault($nmac8)))((0, $a3a83d550ecd5f0d$export$3ebe670b4d690f8d), (expScorePair)=>expScorePair[0])[0];
        exp = Math.min(maxKey, exp);
        if ((0, $a3a83d550ecd5f0d$export$3ebe670b4d690f8d).find((expScorePair)=>expScorePair[0] === exp)) score = (0, $a3a83d550ecd5f0d$export$3ebe670b4d690f8d).find((expScorePair)=>expScorePair[0] === exp)[1];
    }
    return score;
};
const $6a559403926e01b7$export$f72d9f2009fffb28 = (eduLevel, lanTestInfo)=>{
    const clbs = Object.keys(lanTestInfo).map((testSubject)=>lanTestInfo[testSubject].clb);
    const lanFactor = $6a559403926e01b7$var$lanToLanFactor(clbs);
    const eduFactor = $6a559403926e01b7$var$eduLevelToEduFactor(eduLevel);
    const multipliedFactor = lanFactor * eduFactor;
    let score = 0;
    if ((0, $a3a83d550ecd5f0d$export$9166a57ad091bff8).find((factorScorePair)=>factorScorePair[0] === multipliedFactor)) score = (0, $a3a83d550ecd5f0d$export$9166a57ad091bff8).find((factorScorePair)=>factorScorePair[0] === multipliedFactor)[1];
    return score;
};
const $6a559403926e01b7$export$1fed8e959d61377b = (eduLevel, exp)=>{
    const expFactor = $6a559403926e01b7$var$expToExpFactor(exp);
    const eduFactor = $6a559403926e01b7$var$eduLevelToEduFactor(eduLevel);
    const multipliedFactor = expFactor * eduFactor;
    let score = 0;
    if ((0, $a3a83d550ecd5f0d$export$9166a57ad091bff8).find((factorScorePair)=>factorScorePair[0] === multipliedFactor)) score = (0, $a3a83d550ecd5f0d$export$9166a57ad091bff8).find((factorScorePair)=>factorScorePair[0] === multipliedFactor)[1];
    return score;
};
const $6a559403926e01b7$export$79d91f9f33e2e534 = (overseasExp, lanTestInfo)=>{
    const clbs = Object.keys(lanTestInfo).map((testSubject)=>lanTestInfo[testSubject].clb);
    const lanFactor = $6a559403926e01b7$var$lanToLanFactor(clbs);
    const overseasExpFactor = $6a559403926e01b7$var$overseasExpToOverseasExpFactor(overseasExp);
    const multipliedFactor = lanFactor * overseasExpFactor;
    let score = 0;
    if ((0, $a3a83d550ecd5f0d$export$8c9d8ffc736b3e6c).find((factorScorePair)=>factorScorePair[0] === multipliedFactor)) score = (0, $a3a83d550ecd5f0d$export$8c9d8ffc736b3e6c).find((factorScorePair)=>factorScorePair[0] === multipliedFactor)[1];
    return score;
};
const $6a559403926e01b7$export$9cf1bc2acfeec73d = (hasCertificate, lanTestInfo)=>{
    const clbs = Object.keys(lanTestInfo).map((testSubject)=>lanTestInfo[testSubject].clb);
    const lanFactor = $6a559403926e01b7$var$lanToLanFactor(clbs, 5, 7);
    const certificateFactor = hasCertificate ? 1 : 0;
    const multipliedFactor = lanFactor * certificateFactor;
    let score = 0;
    if ((0, $a3a83d550ecd5f0d$export$be16cf434455d79f).find((factorScorePair)=>factorScorePair[0] === multipliedFactor)) score = (0, $a3a83d550ecd5f0d$export$be16cf434455d79f).find((factorScorePair)=>factorScorePair[0] === multipliedFactor)[1];
    return score;
};
const $6a559403926e01b7$export$16e1782641a99723 = (overseasExp, exp)=>{
    const expFactor = $6a559403926e01b7$var$expToExpFactor(exp);
    const overseasExpFactor = $6a559403926e01b7$var$overseasExpToOverseasExpFactor(overseasExp);
    const multipliedFactor = expFactor * overseasExpFactor;
    let score = 0;
    if ((0, $a3a83d550ecd5f0d$export$8c9d8ffc736b3e6c).find((factorScorePair)=>factorScorePair[0] === multipliedFactor)) score = (0, $a3a83d550ecd5f0d$export$8c9d8ffc736b3e6c).find((factorScorePair)=>factorScorePair[0] === multipliedFactor)[1];
    return score;
};
const $6a559403926e01b7$export$1cd02d2f0f702803 = (rawEduMultiplyLanScore, rawEduMultiplyExpScore)=>{
    const eduMultiplyLanScore = Number(rawEduMultiplyLanScore);
    const eduMultiplyExpScore = Number(rawEduMultiplyExpScore);
    if (Number.isNaN(eduMultiplyLanScore) || Number.isNaN(eduMultiplyExpScore)) return 0;
    return Math.min(50, eduMultiplyLanScore + eduMultiplyExpScore);
};
const $6a559403926e01b7$export$94b3a8bd836596a5 = (rawOverseasExpMultiplyLanScore, rawOverseasExpMultiplyExpScore)=>{
    const overseasExpMultiplyLanScore = Number(rawOverseasExpMultiplyLanScore);
    const overseasExpMultiplyExpScore = Number(rawOverseasExpMultiplyExpScore);
    if (Number.isNaN(overseasExpMultiplyLanScore) || Number.isNaN(overseasExpMultiplyExpScore)) return 0;
    return Math.min(50, overseasExpMultiplyLanScore + overseasExpMultiplyExpScore);
};
const $6a559403926e01b7$export$313c2cf4d32e1ee8 = (passed)=>{
    if (passed) return 0, $a3a83d550ecd5f0d$export$96bf579af963ed26;
    return 0;
};
const $6a559403926e01b7$export$5bcd3e6960cd8450 = (employerType)=>{
    if (!(0, $a3a83d550ecd5f0d$export$ff5a5eabd004a88f).find((type)=>type === employerType)) return 0;
    let score = 0;
    if ((0, $a3a83d550ecd5f0d$export$68dbab1836f00a90).find((typeScorePair)=>typeScorePair[0] === employerType)) score = (0, $a3a83d550ecd5f0d$export$68dbab1836f00a90).find((typeScorePair)=>typeScorePair[0] === employerType)[1];
    return score;
};
const $6a559403926e01b7$export$6ae8ae1d77fc99c8 = (canadaEduDegree)=>{
    if (!(0, $a3a83d550ecd5f0d$export$1a569da8b8981cce).find((degree)=>degree === canadaEduDegree)) return 0;
    let score = 0;
    if ((0, $a3a83d550ecd5f0d$export$d2702c1a8faa626a).find((degreeScorePair)=>degreeScorePair[0] === canadaEduDegree)) score = (0, $a3a83d550ecd5f0d$export$d2702c1a8faa626a).find((degreeScorePair)=>degreeScorePair[0] === canadaEduDegree)[1];
    return score;
};
const $6a559403926e01b7$export$b4ece03dd5931181 = (hasSibling)=>{
    if (hasSibling) return 0, $a3a83d550ecd5f0d$export$5fbea886f7806b1b;
    return 0;
};
const $6a559403926e01b7$export$72af6bd96d26129a = (firstLanTestType, firstLanTestInfo, secondLanTestType, secondLanTestInfo)=>{
    let frenchClbs = [
        0,
        0,
        0,
        0
    ];
    let englishClbs = [
        0,
        0,
        0,
        0
    ];
    if ((0, $a3a83d550ecd5f0d$export$a1e00d3d088e80f7).includes(firstLanTestType)) englishClbs = Object.keys(firstLanTestInfo).map((testSubject)=>firstLanTestInfo[testSubject].clb);
    else if ((0, $a3a83d550ecd5f0d$export$a1e00d3d088e80f7).includes(secondLanTestType)) englishClbs = Object.keys(secondLanTestInfo).map((testSubject)=>secondLanTestInfo[testSubject].clb);
    if ((0, $a3a83d550ecd5f0d$export$1034dbf5e1792b92).includes(firstLanTestType)) frenchClbs = Object.keys(firstLanTestInfo).map((testSubject)=>firstLanTestInfo[testSubject].clb);
    else if ((0, $a3a83d550ecd5f0d$export$1034dbf5e1792b92).includes(secondLanTestType)) frenchClbs = Object.keys(secondLanTestInfo).map((testSubject)=>secondLanTestInfo[testSubject].clb);
    let score = 0;
    let frenchFactor = 0;
    let englishFactor = 1;
    let multipliedFactor = 0;
    if ($6a559403926e01b7$var$allClbsAbove(frenchClbs, 7)) frenchFactor = 1;
    if ($6a559403926e01b7$var$allClbsAbove(englishClbs, 5)) englishFactor = 2;
    multipliedFactor = frenchFactor * englishFactor;
    if ((0, $a3a83d550ecd5f0d$export$7d1a62c422ad3a6b).find((factorScorePair)=>factorScorePair[0] === multipliedFactor)) score = (0, $a3a83d550ecd5f0d$export$7d1a62c422ad3a6b).find((factorScorePair)=>factorScorePair[0] === multipliedFactor)[1];
    return score;
};
const $6a559403926e01b7$export$fd41686132ea204 = (provincialNomineePassed, employerType, canadaEduDegree, hasSibling, frenchScore)=>{
    const provincialNomineeScore = $6a559403926e01b7$export$313c2cf4d32e1ee8(provincialNomineePassed);
    const employerScore = $6a559403926e01b7$export$5bcd3e6960cd8450(employerType);
    const canadaEduScore = $6a559403926e01b7$export$6ae8ae1d77fc99c8(canadaEduDegree);
    const siblingScore = $6a559403926e01b7$export$b4ece03dd5931181(hasSibling);
    if (Number.isNaN(provincialNomineeScore) || Number.isNaN(employerScore) || Number.isNaN(canadaEduScore) || Number.isNaN(siblingScore) || Number.isNaN(frenchScore)) return 0;
    return Math.min(600, provincialNomineeScore + employerScore + canadaEduScore + siblingScore + frenchScore);
};
const $6a559403926e01b7$export$9d5186fa87602c3e = (rawAgeScore = 0, rawEduScore = 0, rawFirstLanScore = 0, rawExpScore = 0, rawSecondLanScore = 0, rawSpouseEduScore = 0, rawSpouseLanScore = 0, rawSpouseExpScore = 0, rawTransferEduScore = 0, rawTransferOverseasExpScore = 0, rawTransferCertificateScore = 0, rawAdditionalScore = 0)=>{
    const ageScore = Number(rawAgeScore);
    const eduScore = Number(rawEduScore);
    const firstLanScore = Number(rawFirstLanScore);
    const expScore = Number(rawExpScore);
    const secondLanScore = Number(rawSecondLanScore);
    const spouseEduScore = Number(rawSpouseEduScore);
    const spouseLanScore = Number(rawSpouseLanScore);
    const spouseExpScore = Number(rawSpouseExpScore);
    const transferEduScore = Number(rawTransferEduScore);
    const transferOverseasExpScore = Number(rawTransferOverseasExpScore);
    const transferCertificateScore = Number(rawTransferCertificateScore);
    const additionalScore = Number(rawAdditionalScore);
    if (Number.isNaN(ageScore) || Number.isNaN(eduScore) || Number.isNaN(firstLanScore) || Number.isNaN(expScore) || Number.isNaN(secondLanScore) || Number.isNaN(spouseEduScore) || Number.isNaN(spouseLanScore) || Number.isNaN(spouseExpScore) || Number.isNaN(transferEduScore) || Number.isNaN(transferOverseasExpScore) || Number.isNaN(transferCertificateScore) || Number.isNaN(additionalScore)) return 0;
    const transferScore = Math.min(100, transferEduScore + transferOverseasExpScore + transferCertificateScore);
    return ageScore + eduScore + firstLanScore + expScore + secondLanScore + spouseEduScore + spouseExpScore + spouseLanScore + transferScore + additionalScore;
};
const $6a559403926e01b7$export$4bcec7b16b4a3a81 = (maxScore, realScore)=>{
    const MaxAndRealScores = (0, $4e8e25f2759d26d8$export$e193c227f15db60d)(({ maxScore: maxScore, realScore: realScore })=>{
        return (0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($6a559403926e01b7$var$t || ($6a559403926e01b7$var$t = $6a559403926e01b7$var$_`<strong style="white-space: nowrap;"
      >${0}/${0}</strong
    >`), realScore, maxScore);
    });
    return MaxAndRealScores({
        maxScore: maxScore,
        realScore: realScore
    });
};
function $6a559403926e01b7$var$allClbsAbove(clbs = [
    0,
    0,
    0,
    0
], rawLevel) {
    const level = Number(rawLevel);
    let flag = false;
    if (!Number.isNaN(level) && level <= 10 && clbs.every((rawClb)=>{
        const clb = Number(rawClb);
        if (!Number.isNaN(clb) && (0, (/*@__PURE__*/$parcel$interopDefault($7a8bedae7ee068a0$exports)))(clb, level, 10.001)) return true;
        return false;
    })) flag = true;
    return flag;
}
function $6a559403926e01b7$var$lanToLanFactor(clbs = [
    0,
    0,
    0,
    0
], firstLevel = 7, secondLevel = 9) {
    let lanFactor = 0;
    if ($6a559403926e01b7$var$allClbsAbove(clbs, firstLevel)) lanFactor = 1;
    if ($6a559403926e01b7$var$allClbsAbove(clbs, secondLevel)) lanFactor = 2;
    return lanFactor;
}
function $6a559403926e01b7$var$eduLevelToEduFactor(eduLevel) {
    if (!(0, $a3a83d550ecd5f0d$export$4d6163d904b950e2).find((level)=>level === eduLevel)) return 0;
    let eduFactor = 0;
    const eduIndex = (0, $a3a83d550ecd5f0d$export$4d6163d904b950e2).findIndex((level)=>level === eduLevel);
    if (eduIndex >= 2) eduFactor = 1;
    if (eduIndex >= 5) eduFactor = 2;
    return eduFactor;
}
function $6a559403926e01b7$var$expToExpFactor(rawExp) {
    const exp = Number(rawExp);
    if (Number.isNaN(exp) || exp < 1) return 0;
    let expFactor = 0;
    if (exp >= 1) expFactor = 1;
    if (exp >= 2) expFactor = 2;
    return expFactor;
}
function $6a559403926e01b7$var$overseasExpToOverseasExpFactor(rawOverseasExp) {
    const overseasExp = Number(rawOverseasExp);
    if (Number.isNaN(overseasExp) || overseasExp < 1) return 0;
    let overseasExpFactor = 0;
    if (overseasExp >= 1) overseasExpFactor = 1;
    if (overseasExp >= 3) overseasExpFactor = 2;
    return overseasExpFactor;
}




let $9cbc01911585fbef$var$_ = (t)=>t, $9cbc01911585fbef$var$t, $9cbc01911585fbef$var$t1, $9cbc01911585fbef$var$t2, $9cbc01911585fbef$var$t3, $9cbc01911585fbef$var$t4, $9cbc01911585fbef$var$t5, $9cbc01911585fbef$var$t6, $9cbc01911585fbef$var$t7, $9cbc01911585fbef$var$t8, $9cbc01911585fbef$var$t9, $9cbc01911585fbef$var$t10, $9cbc01911585fbef$var$t11, $9cbc01911585fbef$var$t12, $9cbc01911585fbef$var$t13, $9cbc01911585fbef$var$t14, $9cbc01911585fbef$var$t15, $9cbc01911585fbef$var$t16, $9cbc01911585fbef$var$t17, $9cbc01911585fbef$var$t18, $9cbc01911585fbef$var$t19, $9cbc01911585fbef$var$t20, $9cbc01911585fbef$var$t21, $9cbc01911585fbef$var$t22, $9cbc01911585fbef$var$t23;
function $9cbc01911585fbef$var$CRSForm() {
    const initialTestInfo = {};
    (0, $a3a83d550ecd5f0d$export$c06f55024bb06ed4).forEach((subject)=>{
        initialTestInfo[subject] = {
            testScore: 0,
            clb: 0,
            score: 0
        };
    });
    const [isSingle, setIsSingle] = (0, $5cdad80541da5d1a$export$60241385465d0a34)(true);
    const [age, setAge] = (0, $5cdad80541da5d1a$export$60241385465d0a34)(null);
    const [eduLevel, setEduLevel] = (0, $5cdad80541da5d1a$export$60241385465d0a34)(null);
    const [firstLanTestType, setFirstLanTestType] = (0, $5cdad80541da5d1a$export$60241385465d0a34)(null);
    const [firstLanTestInfo, setFirstLanTestInfo] = (0, $5cdad80541da5d1a$export$60241385465d0a34)(initialTestInfo);
    const [secondLanEnabled, setSecondLanEnabled] = (0, $5cdad80541da5d1a$export$60241385465d0a34)(false);
    const [secondLanTestType, setSecondLanTestType] = (0, $5cdad80541da5d1a$export$60241385465d0a34)(null);
    const [secondLanTestInfo, setSecondLanTestInfo] = (0, $5cdad80541da5d1a$export$60241385465d0a34)(initialTestInfo);
    const [exp, setExp] = (0, $5cdad80541da5d1a$export$60241385465d0a34)(null);
    const [overseasExp, setOverseasExp] = (0, $5cdad80541da5d1a$export$60241385465d0a34)(null);
    const [spouseEduLevel, setSpouseEduLevel] = (0, $5cdad80541da5d1a$export$60241385465d0a34)(null);
    const [spouseLanEnabled, setSpouseLanEnabled] = (0, $5cdad80541da5d1a$export$60241385465d0a34)(false);
    const [spouseLanTestType, setSpouseLanTestType] = (0, $5cdad80541da5d1a$export$60241385465d0a34)(null);
    const [spouseLanTestInfo, setSpouseLanTestInfo] = (0, $5cdad80541da5d1a$export$60241385465d0a34)(initialTestInfo);
    const [spouseExp, setSpouseExp] = (0, $5cdad80541da5d1a$export$60241385465d0a34)(null);
    const [hasProvincialNominee, setHasProvincialNominee] = (0, $5cdad80541da5d1a$export$60241385465d0a34)(false);
    const [employerType, setEmployerType] = (0, $5cdad80541da5d1a$export$60241385465d0a34)(null);
    const [canadaEduDegree, setCanadaEduDegree] = (0, $5cdad80541da5d1a$export$60241385465d0a34)(null);
    const [hasSibling, setHasSibling] = (0, $5cdad80541da5d1a$export$60241385465d0a34)(false);
    const [hasCertificate, setHasCertificate] = (0, $5cdad80541da5d1a$export$60241385465d0a34)(false);
    (0, $f7659344dcec8608$export$6d9c69b0de29b591)(()=>{
        if (secondLanTestType === null) this.querySelectorAll('[name="secondLanTestType"]').forEach((radioButton)=>{
            radioButton.checked = false;
        });
    }, [
        secondLanTestType
    ]);
    const onIsSingleChanged = (e, isSingleCheckbox)=>{
        console.log(isSingleCheckbox);
        if (isSingleCheckbox) {
            setIsSingle(e.target.checked);
            if (e.target.checked) {
                setSpouseEduLevel(null);
                setSpouseLanEnabled(false);
                setSpouseLanTestType(null);
                setSpouseLanTestInfo(initialTestInfo);
                setSpouseExp(null);
            }
        } else setIsSingle(!e.target.checked);
        setFirstLanTestInfo((firstLanTestInfo)=>{
            let newFirstLanTestInfo = {};
            Object.keys(firstLanTestInfo).forEach((testSubject)=>{
                const testScore = firstLanTestInfo[testSubject].testScore;
                const clb = firstLanTestInfo[testSubject].clb;
                newFirstLanTestInfo[testSubject] = {
                    testScore: testScore,
                    clb: clb,
                    score: (0, $6a559403926e01b7$export$3a0e8dc9544a08b)(clb, isSingleCheckbox ? e.target.checked : !e.target.checked, false, true)
                };
            });
            return newFirstLanTestInfo;
        });
        if (secondLanEnabled) setSecondLanTestInfo((secondLanTestInfo)=>{
            let newSecondLanTestInfo = {};
            Object.keys(secondLanTestInfo).forEach((testSubject)=>{
                const testScore = secondLanTestInfo[testSubject].testScore;
                const clb = secondLanTestInfo[testSubject].clb;
                newSecondLanTestInfo[testSubject] = {
                    testScore: testScore,
                    clb: clb,
                    score: (0, $6a559403926e01b7$export$3a0e8dc9544a08b)(clb, e.target.checked, false, false)
                };
            });
            return newSecondLanTestInfo;
        });
    };
    const onAgeChanged = (e)=>{
        console.log(e);
        const rawAge = e.target.value;
        const age = Number(rawAge);
        if (!Number.isNaN(age) && age > 0 && age < 100) setAge(age);
        else setAge(null);
    };
    const onFirstLanTestTypeChanged = (e)=>{
        if ((0, $a3a83d550ecd5f0d$export$a1e00d3d088e80f7).includes(e.target.value) && !(0, $a3a83d550ecd5f0d$export$a1e00d3d088e80f7).includes(firstLanTestType) || (0, $a3a83d550ecd5f0d$export$1034dbf5e1792b92).includes(e.target.value) && !(0, $a3a83d550ecd5f0d$export$1034dbf5e1792b92).includes(firstLanTestType)) {
            setSecondLanTestType(null);
            setSecondLanTestInfo(initialTestInfo);
        }
        setFirstLanTestType(e.target.value);
        setFirstLanTestInfo((firstLanTestInfo)=>{
            let newFirstLanTestInfo = {};
            Object.keys(firstLanTestInfo).forEach((testSubject)=>{
                const testScore = firstLanTestInfo[testSubject].testScore;
                newFirstLanTestInfo[testSubject] = {
                    testScore: testScore,
                    clb: (0, $6a559403926e01b7$export$6e4aeae4b932ab52)(testScore, e.target.value, testSubject),
                    score: (0, $6a559403926e01b7$export$3a0e8dc9544a08b)((0, $6a559403926e01b7$export$6e4aeae4b932ab52)(testScore, e.target.value, testSubject), isSingle, false, true)
                };
            });
            return newFirstLanTestInfo;
        });
    };
    const onFirstLanChanged = (e, testSubject)=>{
        const rawTestScore = e.target.value;
        const testScore = Number(rawTestScore);
        if (!Number.isNaN(testScore)) setFirstLanTestInfo((firstLanTestInfo)=>{
            return (0, $c819c676e77e1119$export$71511d61b312f219)((0, $6bdeba009fe4f140$export$71511d61b312f219)({}, firstLanTestInfo), {
                [testSubject]: {
                    testScore: testScore,
                    clb: (0, $6a559403926e01b7$export$6e4aeae4b932ab52)(testScore, firstLanTestType, testSubject),
                    score: (0, $6a559403926e01b7$export$3a0e8dc9544a08b)((0, $6a559403926e01b7$export$6e4aeae4b932ab52)(testScore, firstLanTestType, testSubject), isSingle, false, true)
                }
            });
        });
    };
    const onSecondLanEnabledChanged = (e)=>{
        setSecondLanEnabled(e.target.checked);
        if (e.target.checked === false) {
            setSecondLanTestType(null);
            setSecondLanTestInfo(initialTestInfo);
        }
    };
    const onSecondLanTestTypeChanged = (e)=>{
        setSecondLanTestType(e.target.value);
        setSecondLanTestInfo((secondLanTestInfo)=>{
            let newSecondLanTestInfo = {};
            Object.keys(secondLanTestInfo).forEach((testSubject)=>{
                const testScore = secondLanTestInfo[testSubject].testScore;
                newSecondLanTestInfo[testSubject] = {
                    testScore: testScore,
                    clb: (0, $6a559403926e01b7$export$6e4aeae4b932ab52)(testScore, e.target.value, testSubject),
                    score: (0, $6a559403926e01b7$export$3a0e8dc9544a08b)((0, $6a559403926e01b7$export$6e4aeae4b932ab52)(testScore, e.target.value, testSubject), isSingle, false, false)
                };
            });
            return newSecondLanTestInfo;
        });
    };
    const onSecondLanChanged = (e, testSubject)=>{
        const rawTestScore = e.target.value;
        const testScore = Number(rawTestScore);
        if (!Number.isNaN(testScore)) setSecondLanTestInfo((secondLanTestInfo)=>{
            return (0, $c819c676e77e1119$export$71511d61b312f219)((0, $6bdeba009fe4f140$export$71511d61b312f219)({}, secondLanTestInfo), {
                [testSubject]: {
                    testScore: testScore,
                    clb: (0, $6a559403926e01b7$export$6e4aeae4b932ab52)(testScore, secondLanTestType, testSubject),
                    score: (0, $6a559403926e01b7$export$3a0e8dc9544a08b)((0, $6a559403926e01b7$export$6e4aeae4b932ab52)(testScore, secondLanTestType, testSubject), isSingle, false, false)
                }
            });
        });
    };
    const onExpChanged = (e)=>{
        const rawExp = e.target.value;
        const exp = Number(rawExp);
        if (!Number.isNaN(exp) && exp >= 0) setExp(exp);
        else setExp(null);
    };
    const onOverseasExpChanged = (e)=>{
        const rawOverseasExp = e.target.value;
        const overseasExp = Number(rawOverseasExp);
        if (!Number.isNaN(overseasExp) && overseasExp >= 0) setOverseasExp(overseasExp);
        else setOverseasExp(null);
    };
    const onSpouseLanEnabledChanged = (e)=>{
        setSpouseLanEnabled(e.target.checked);
        if (e.target.checked === false) {
            setSpouseLanTestType(null);
            setSpouseLanTestInfo(initialTestInfo);
        }
    };
    const onSpouseLanTestTypeChanged = (e)=>{
        setSpouseLanTestType(e.target.value);
        setSpouseLanTestInfo((spouseLanTestInfo)=>{
            let newSpouseLanTestInfo = {};
            Object.keys(spouseLanTestInfo).forEach((testSubject)=>{
                const testScore = spouseLanTestInfo[testSubject].testScore;
                const clb = (0, $6a559403926e01b7$export$6e4aeae4b932ab52)(testScore, e.target.value, testSubject);
                newSpouseLanTestInfo[testSubject] = {
                    testScore: testScore,
                    clb: clb,
                    score: (0, $6a559403926e01b7$export$3a0e8dc9544a08b)(clb, isSingle, true, false)
                };
            });
            return newSpouseLanTestInfo;
        });
    };
    const onSpouseLanChanged = (e, testSubject)=>{
        const rawTestScore = e.target.value;
        const testScore = Number(rawTestScore);
        if (!Number.isNaN(testScore)) setSpouseLanTestInfo((spouseLanTestInfo)=>{
            return (0, $c819c676e77e1119$export$71511d61b312f219)((0, $6bdeba009fe4f140$export$71511d61b312f219)({}, spouseLanTestInfo), {
                [testSubject]: {
                    testScore: testScore,
                    clb: (0, $6a559403926e01b7$export$6e4aeae4b932ab52)(testScore, spouseLanTestType, testSubject),
                    score: (0, $6a559403926e01b7$export$3a0e8dc9544a08b)((0, $6a559403926e01b7$export$6e4aeae4b932ab52)(testScore, spouseLanTestType, testSubject), isSingle, true, false)
                }
            });
        });
    };
    const onSpouseExpChanged = (e)=>{
        const rawSpouseExp = e.target.value;
        const spouseExp = Number(rawSpouseExp);
        if (!Number.isNaN(spouseExp) && spouseExp >= 0) setSpouseExp(spouseExp);
        else setSpouseExp(null);
    };
    const onHasProvincialNomineeChanged = (e)=>{
        setHasProvincialNominee(e.target.checked);
    };
    const onEmployerTypeChanged = (e)=>{
        setEmployerType(e.target.value);
    };
    const onCanadaEduDegreeChanged = (e)=>{
        setCanadaEduDegree(e.target.value);
    };
    const onHasSiblingChanged = (e)=>{
        setHasSibling(e.target.checked);
    };
    const onHasCertificateChanged = (e)=>{
        setHasCertificate(e.target.checked);
    };
    return (0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($9cbc01911585fbef$var$t23 || ($9cbc01911585fbef$var$t23 = $9cbc01911585fbef$var$_`<div style="overflow-x: auto;">
      <table class="table table-bordered crs-table-inner">
        <tbody>
          <tr>
            <td width="15%">婚姻</td>
            <td colspan="2">
              <label>
                <input
                  type="radio"
                  name="maritalStatus"
                  ?checked=${0}
                  @change=${0}
                />
                单身或不带伴侣申请
              </label>
              <label>
                <input
                  type="radio"
                  name="maritalStatus"
                  ?checked=${0}
                  @change=${0}
                />
                带配偶或伴侣申请
              </label>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              A. 核心/人力资本因素 Core / human capital factors
            </td>
            <td>
              ${0}
            </td>
          </tr>
          <tr>
            <td>年龄</td>
            <td width="70%" class="left">
              <select
                name="age"
                @change=${0}
                style="width: 200px; max-width: 100%;"
              >
                ${0}
              </select>
            </td>
            <td width="15%"><span>${0}</span></td>
          </tr>
          <tr>
            <td>学历</td>
            <td class="left">
              <div class="form-group">
                <label>现有最高学历</label>
                ${0}
              </div>
              <br />
              <div class="form-group">
                <label>在加拿大取得的最高学历</label>
                ${0}
              </div>
              <div class="checkbox">
                <label>
                  <input
                    type="checkbox"
                    ?checked=${0}
                    @change=${0}
                  />
                  我有加拿大认证的专业技工证书（如Red Seal证书）
                </label>
              </div>
            </td>
            <td><span>${0}</span></td>
          </tr>
          <tr>
            <td>第一语言</td>
            <td class="left">
              ${0}
              ${0}
            </td>
            <td>
              <span
                >${0}</span
              >
            </td>
          </tr>
          ${0}
          <tr>
            <td>工作经验</td>
            <td class="left">
              <div class="form-group">
                <label>加拿大工作经验（可以不连续）</label>
                ${0}
              </div>
              <br />
              <div class="form-group">
                <label>非加拿大工作经验（可以不连续）</label>
                ${0}
              </div>
              <p>
                非加拿大的工作经验不能直接产生分数，但是在后续交叉项有可能算分<br />
                工作经验必须是NOC的0、A或者B类
              </p>
            </td>
            <td><span>${0}</span></td>
          </tr>
          <tr>
            <td colspan="2">B. 配偶因素 Spouse factors</td>
            <td>
              ${0}
            </td>
          </tr>
          ${0}
          <tr>
            <td colspan="2">
              C. 迁移能力因素（交叉项） Skill transferability factors
            </td>
            <td>
              ${0}
            </td>
          </tr>
          <tr>
            <td>
              教育<br />
              最高50分
            </td>
            <td class="left">
              <div class="form-group">
                <label>本栏自动计算分数</label>
                <p>教育背景x语言能力</p>
                <p>
                  您的得分：
                  <span>
                    ${0}
                  </span>
                </p>
                <ul>
                  <li>
                    <p>
                      1年大专及以上<strong>同时</strong>第一语言每一项都有CLB7级（含）以上，可以获得分数
                    </p>
                  </li>
                  <li>
                    <p>
                      双学位以上或者第一语言每一项都有CLB9级（含）以上，会有更多分数
                    </p>
                  </li>
                </ul>
                <p>教育背景x加拿大工作经验</p>
                <p>
                  您的得分：
                  <span>${0}</span>
                </p>
                <ul>
                  <li>
                    <p>
                      1年大专及以上<strong>同时</strong>加拿大工作过1年，可以获得分数
                    </p>
                  </li>
                  <li><p>双学位以上或者加拿大工作两年以上，会有更多分数</p></li>
                </ul>
              </div>
            </td>
            <td>
              <span>
                ${0}
              </span>
            </td>
          </tr>
          <tr>
            <td>
              海外工作经验<br />
              最高50分
            </td>
            <td class="left">
              <div class="form-group">
                <label>本栏自动计算分数</label>
                <p>海外（包括中国）工作经验x语言能力</p>
                <p>
                  您的得分：
                  <span>
                    ${0}
                  </span>
                </p>
                <ul>
                  <li>
                    <p>
                      1年海外工作经历<strong>同时</strong>第一语言每一项都有CLB7级（含）以上，可以获得分数
                    </p>
                  </li>
                  <li>
                    <p>
                      3年海外工作经历或者第一语言每一项都有CLB9级（含）以上，会有更多分数
                    </p>
                  </li>
                </ul>
                <p>海外工作经验x加拿大工作经验</p>
                <p>
                  您的得分：
                  <span>
                    ${0}
                  </span>
                </p>
                <ul>
                  <li>
                    <p>
                      海外工作1年<strong>同时</strong>加拿大工作1年，可以获得分数
                    </p>
                  </li>
                  <li>
                    <p>3年海外工作经历或者加拿大工作两年以上，会有更多分数</p>
                  </li>
                </ul>
              </div>
            </td>
            <td>
              <span
                >${0}</span
              >
            </td>
          </tr>
          <tr>
            <td>
              技工证书<br />
              最高50分
            </td>
            <td class="left">
              <div class="form-group">
                <label>本栏自动计算分数</label>
                <p>加拿大认证的专业技工证书x语言能力</p>
                <p>
                  您的得分：
                  <span>
                    ${0}
                  </span>
                </p>
                <ul>
                  <li>
                    <p>
                      拥有加拿大认证的专业技工证书<strong>同时</strong>第一语言每一项都有CLB5级（含）以上，可以获得分数
                    </p>
                  </li>
                  <li>
                    <p>
                      拥有加拿大认证的专业技工证书<strong>同时</strong>第一语言每一项都有CLB7级（含）以上，会有更多分数
                    </p>
                  </li>
                </ul>
              </div>
            </td>
            <td>
              <span
                >${0}</span
              >
            </td>
          </tr>
          <tr>
            <td colspan="2">D. 附加分 Additional points</td>
            <td>
              ${0}
            </td>
          </tr>
          <tr>
            <td>省提名</td>
            <td class="left">
              <div class="checkbox">
                <label>
                  <input
                    type="checkbox"
                    ?checked=${0}
                    @change=${0}
                  />
                  我有支持EE加分的省提名
                </label>
              </div>
            </td>
            <td>
              <span>
                ${0}
              </span>
            </td>
          </tr>
          <tr>
            <td>雇主担保（LMIA或者封闭式工签）</td>
            <td class="left">
              ${0}
            </td>
            <td>
              <span>${0}</span>
            </td>
          </tr>
          <tr>
            <td>加拿大学历加分</td>
            <td class="left"><p>取得过加拿大学历自动产生附加分。</p></td>
            <td>
              <span>${0}</span>
            </td>
          </tr>
          <tr>
            <td>法语加分</td>
            <td class="left"><p>法语达到 CLB7 以上会自动产生附加分。</p></td>
            <td>
              <span
                >${0}</span
              >
            </td>
          </tr>
          <tr>
            <td>兄弟姐妹加分</td>
            <td class="left">
              <div class="checkbox">
                <label>
                  <input
                    type="checkbox"
                    ?checked=${0}
                    @change=${0}
                  />
                  申请人或配偶有加拿大兄弟姐妹
                </label>
              </div>
            </td>
            <td>
              <span>${0}</span>
            </td>
          </tr>
          <tr>
            <td colspan="2">总分</td>
            <td>
              <span>
                ${0}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <style>
      .crs-table-inner .radio:first-child {
        margin-top: 0;
      }
      .crs-table-inner .form-group {
        margin-bottom: 0;
      }
      .crs-table-inner .form-group ul {
        padding-left: 20px;
      }
      .crs-table-inner p {
        max-height: 999999px;
      }
    </style>`), isSingle, (e)=>onIsSingleChanged(e, true), !isSingle, (e)=>onIsSingleChanged(e, false), (0, $6a559403926e01b7$export$4bcec7b16b4a3a81)(isSingle ? 500 : 460, (0, $6a559403926e01b7$export$a2af4d04d4184fe2)(age, isSingle) + (0, $6a559403926e01b7$export$231d4b88776bb861)(eduLevel, isSingle, false) + (0, $6a559403926e01b7$export$12b9b47f34fd261)(firstLanTestInfo, isSingle, false, true) + (0, $6a559403926e01b7$export$12b9b47f34fd261)(secondLanTestInfo, isSingle, false, false) + (0, $6a559403926e01b7$export$4d121d8ff4b62f32)(exp, isSingle, false)), onAgeChanged, (0, $a3a83d550ecd5f0d$export$d62335b9c14fe5c1).map((level)=>(0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($9cbc01911585fbef$var$t || ($9cbc01911585fbef$var$t = $9cbc01911585fbef$var$_`<option value=${0}>${0}</option>`), level, level)), (0, $6a559403926e01b7$export$a2af4d04d4184fe2)(age, isSingle), (0, $a3a83d550ecd5f0d$export$4d6163d904b950e2).map((eduLevelName)=>(0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($9cbc01911585fbef$var$t1 || ($9cbc01911585fbef$var$t1 = $9cbc01911585fbef$var$_`<div class="radio">
                      <label>
                        <input
                          type="radio"
                          value=${0}
                          name="eduLevel"
                          ?checked=${0}
                          @change=${0}
                        />
                        ${0}
                      </label>
                    </div>`), eduLevelName, eduLevel === eduLevelName, (e)=>setEduLevel(e.target.value), eduLevelName)), (0, $a3a83d550ecd5f0d$export$1a569da8b8981cce).map((canadaEduDegreeName)=>(0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($9cbc01911585fbef$var$t2 || ($9cbc01911585fbef$var$t2 = $9cbc01911585fbef$var$_`<div class="radio">
                      <label>
                        <input
                          type="radio"
                          value=${0}
                          name="canadaEduDegree"
                          ?checked=${0}
                          @change=${0}
                        />
                        ${0}
                      </label>
                    </div>`), canadaEduDegreeName, canadaEduDegree === canadaEduDegreeName, onCanadaEduDegreeChanged, canadaEduDegreeName)), hasCertificate, onHasCertificateChanged, (0, $6a559403926e01b7$export$231d4b88776bb861)(eduLevel, isSingle, false), (0, $a3a83d550ecd5f0d$export$a161b1198dd9cbf0).map((testType)=>(0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($9cbc01911585fbef$var$t3 || ($9cbc01911585fbef$var$t3 = $9cbc01911585fbef$var$_`<div class="radio">
                    <label>
                      <input
                        type="radio"
                        value=${0}
                        name="firstLanTestType"
                        ?checked=${0}
                        @change=${0}
                      />
                      ${0}
                    </label>
                  </div>`), testType, testType === firstLanTestType, onFirstLanTestTypeChanged, testType)), firstLanTestType && (0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($9cbc01911585fbef$var$t6 || ($9cbc01911585fbef$var$t6 = $9cbc01911585fbef$var$_`${0}
                <div class="checkbox">
                  <label>
                    <input
                      type="checkbox"
                      ?checked=${0}
                      @change=${0}
                    />
                    同时拥有第二门语言成绩
                  </label>
                </div>`), (0, $a3a83d550ecd5f0d$export$c06f55024bb06ed4).map((testSubject)=>(0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($9cbc01911585fbef$var$t5 || ($9cbc01911585fbef$var$t5 = $9cbc01911585fbef$var$_`<div class="form-group">
                      <label>
                        ${0}
                        <input
                          type="text"
                          @keyup=${0}
                        />
                        ${0}
                      </label>
                    </div>`), testSubject, (e)=>onFirstLanChanged(e, testSubject), firstLanTestInfo[testSubject].score > 0 ? (0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($9cbc01911585fbef$var$t4 || ($9cbc01911585fbef$var$t4 = $9cbc01911585fbef$var$_`<span>
                              CLB${0}：${0}分
                            </span>`), firstLanTestInfo[testSubject].clb, firstLanTestInfo[testSubject].score) : null)), secondLanEnabled, onSecondLanEnabledChanged), (0, $6a559403926e01b7$export$12b9b47f34fd261)(firstLanTestInfo, isSingle, false, true), secondLanEnabled ? (0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($9cbc01911585fbef$var$t11 || ($9cbc01911585fbef$var$t11 = $9cbc01911585fbef$var$_`<tr>
                <td>第二语言</td>
                <td class="left">
                  ${0}
                  ${0}
                </td>
                <td>
                  <span
                    >${0}</span
                  >
                </td>
              </tr>`), (0, $a3a83d550ecd5f0d$export$a161b1198dd9cbf0).filter((testType)=>{
        return (0, $a3a83d550ecd5f0d$export$a1e00d3d088e80f7).includes(testType) && !(0, $a3a83d550ecd5f0d$export$a1e00d3d088e80f7).includes(firstLanTestType) || (0, $a3a83d550ecd5f0d$export$1034dbf5e1792b92).includes(testType) && !(0, $a3a83d550ecd5f0d$export$1034dbf5e1792b92).includes(firstLanTestType);
    }).map((testType)=>(0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($9cbc01911585fbef$var$t7 || ($9cbc01911585fbef$var$t7 = $9cbc01911585fbef$var$_`<div class="radio">
                        <label>
                          <input
                            type="radio"
                            value=${0}
                            name="secondLanTestType"
                            ?checked=${0}
                            @change=${0}
                          />
                          ${0}
                        </label>
                      </div>`), testType, testType === secondLanTestType, onSecondLanTestTypeChanged, testType)), secondLanTestType && (0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($9cbc01911585fbef$var$t10 || ($9cbc01911585fbef$var$t10 = $9cbc01911585fbef$var$_`${0}`), (0, $a3a83d550ecd5f0d$export$c06f55024bb06ed4).map((testSubject)=>(0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($9cbc01911585fbef$var$t9 || ($9cbc01911585fbef$var$t9 = $9cbc01911585fbef$var$_`<div class="form-group">
                        <label>
                          ${0}
                          <input
                            type="text"
                            @keyup=${0}
                          />
                          ${0}
                        </label>
                      </div>`), testSubject, (e)=>onSecondLanChanged(e, testSubject), secondLanTestInfo[testSubject].score > 0 ? (0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($9cbc01911585fbef$var$t8 || ($9cbc01911585fbef$var$t8 = $9cbc01911585fbef$var$_`<span>
                                CLB${0}：${0}分
                              </span>`), secondLanTestInfo[testSubject].clb, secondLanTestInfo[testSubject].score) : null))), (0, $6a559403926e01b7$export$12b9b47f34fd261)(secondLanTestInfo, isSingle, false, false)) : null, (0, $a3a83d550ecd5f0d$export$1307a0470afc0a99).map(([expFakeYear, expName])=>(0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($9cbc01911585fbef$var$t12 || ($9cbc01911585fbef$var$t12 = $9cbc01911585fbef$var$_`<div class="radio">
                      <label>
                        <input
                          type="radio"
                          value=${0}
                          name="exp"
                          ?checked=${0}
                          @change=${0}
                        />
                        ${0}
                      </label>
                    </div>`), expFakeYear, exp === expFakeYear, onExpChanged, expName)), (0, $a3a83d550ecd5f0d$export$cf1ea28d35622845).map(([overseasFakeYear, overseasExpName])=>(0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($9cbc01911585fbef$var$t13 || ($9cbc01911585fbef$var$t13 = $9cbc01911585fbef$var$_`<div class="radio">
                      <label>
                        <input
                          type="radio"
                          value=${0}
                          name="overseasExp"
                          ?checked=${0}
                          @change=${0}
                        />
                        ${0}
                      </label>
                    </div>`), overseasFakeYear, overseasExp === overseasFakeYear, onOverseasExpChanged, overseasExpName)), (0, $6a559403926e01b7$export$4d121d8ff4b62f32)(exp, isSingle, false), (0, $6a559403926e01b7$export$4bcec7b16b4a3a81)(isSingle ? 0 : 40, (0, $6a559403926e01b7$export$231d4b88776bb861)(spouseEduLevel, isSingle, true) + (0, $6a559403926e01b7$export$12b9b47f34fd261)(spouseLanTestInfo, isSingle, true, false) + (0, $6a559403926e01b7$export$4d121d8ff4b62f32)(spouseExp, isSingle, true)), !isSingle ? (0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($9cbc01911585fbef$var$t21 || ($9cbc01911585fbef$var$t21 = $9cbc01911585fbef$var$_`<tr>
                  <td>配偶学历</td>
                  <td class="left">
                    ${0}
                    <div class="checkbox">
                      <label>
                        <input
                          type="checkbox"
                          ?checked=${0}
                          @change=${0}
                        />
                        配偶拥有语言成绩
                      </label>
                    </div>
                  </td>
                  <td>
                    <span>${0}</span>
                  </td>
                </tr>
                ${0}

                <tr>
                  <td>配偶工作经验</td>
                  <td class="left">
                    <div class="form-group">
                      <label>加拿大工作经验（可以不连续）</label>
                      ${0}
                    </div>
                    <p>工作经验必须是NOC的0、A或者B类</p>
                  </td>
                  <td>
                    <span>${0}</span>
                  </td>
                </tr>`), (0, $a3a83d550ecd5f0d$export$4d6163d904b950e2).map((eduLevelName)=>(0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($9cbc01911585fbef$var$t14 || ($9cbc01911585fbef$var$t14 = $9cbc01911585fbef$var$_`<div class="radio">
                          <label>
                            <input
                              type="radio"
                              value=${0}
                              name="spouseEduLevel"
                              ?checked=${0}
                              @change=${0}
                            />
                            ${0}
                          </label>
                        </div>`), eduLevelName, spouseEduLevel === eduLevelName, (e)=>setSpouseEduLevel(e.target.value), eduLevelName)), spouseLanEnabled, onSpouseLanEnabledChanged, (0, $6a559403926e01b7$export$231d4b88776bb861)(spouseEduLevel, isSingle, true), spouseLanEnabled ? (0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($9cbc01911585fbef$var$t19 || ($9cbc01911585fbef$var$t19 = $9cbc01911585fbef$var$_`<tr>
                      <td>配偶第一语言</td>
                      <td class="left">
                        ${0}
                        ${0}
                      </td>
                      <td>
                        <span>
                          ${0}
                        </span>
                      </td>
                    </tr>`), (0, $a3a83d550ecd5f0d$export$a161b1198dd9cbf0).map((testType)=>(0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($9cbc01911585fbef$var$t15 || ($9cbc01911585fbef$var$t15 = $9cbc01911585fbef$var$_`<div class="radio">
                              <label>
                                <input
                                  type="radio"
                                  value=${0}
                                  name="spouseLanTestType"
                                  ?checked=${0}
                                  @change=${0}
                                />
                                ${0}
                              </label>
                            </div>`), testType, testType === spouseLanTestType, onSpouseLanTestTypeChanged, testType)), spouseLanTestType && (0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($9cbc01911585fbef$var$t18 || ($9cbc01911585fbef$var$t18 = $9cbc01911585fbef$var$_`${0}`), (0, $a3a83d550ecd5f0d$export$c06f55024bb06ed4).map((testSubject)=>(0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($9cbc01911585fbef$var$t17 || ($9cbc01911585fbef$var$t17 = $9cbc01911585fbef$var$_`<div class="form-group">
                              <label>
                                ${0}
                                <input
                                  type="text"
                                  @keyup=${0}
                                />
                                ${0}
                              </label>
                            </div>`), testSubject, (e)=>onSpouseLanChanged(e, testSubject), spouseLanTestInfo[testSubject].score > 0 ? (0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($9cbc01911585fbef$var$t16 || ($9cbc01911585fbef$var$t16 = $9cbc01911585fbef$var$_`<span>
                                      CLB${0}：${0}分
                                    </span>`), spouseLanTestInfo[testSubject].clb, spouseLanTestInfo[testSubject].score) : null))), (0, $6a559403926e01b7$export$12b9b47f34fd261)(spouseLanTestInfo, isSingle, true, false)) : null, (0, $a3a83d550ecd5f0d$export$1307a0470afc0a99).map(([spouseExpFakeYear, spouseExpName])=>(0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($9cbc01911585fbef$var$t20 || ($9cbc01911585fbef$var$t20 = $9cbc01911585fbef$var$_`<div class="radio">
                            <label>
                              <input
                                type="radio"
                                value=${0}
                                name="spouseExp"
                                ?checked=${0}
                                @change=${0}
                              />
                              ${0}
                            </label>
                          </div>`), spouseExpFakeYear, spouseExp === spouseExpFakeYear, onSpouseExpChanged, spouseExpName)), (0, $6a559403926e01b7$export$4d121d8ff4b62f32)(spouseExp, isSingle, true)) : null, (0, $6a559403926e01b7$export$4bcec7b16b4a3a81)(100, Math.min(100, (0, $6a559403926e01b7$export$1cd02d2f0f702803)((0, $6a559403926e01b7$export$f72d9f2009fffb28)(eduLevel, firstLanTestInfo), (0, $6a559403926e01b7$export$1fed8e959d61377b)(eduLevel, exp)) + (0, $6a559403926e01b7$export$94b3a8bd836596a5)((0, $6a559403926e01b7$export$79d91f9f33e2e534)(overseasExp, firstLanTestInfo), (0, $6a559403926e01b7$export$16e1782641a99723)(overseasExp, exp)) + (0, $6a559403926e01b7$export$9cf1bc2acfeec73d)(hasCertificate, firstLanTestInfo))), (0, $6a559403926e01b7$export$f72d9f2009fffb28)(eduLevel, firstLanTestInfo), (0, $6a559403926e01b7$export$1fed8e959d61377b)(eduLevel, exp), (0, $6a559403926e01b7$export$1cd02d2f0f702803)((0, $6a559403926e01b7$export$f72d9f2009fffb28)(eduLevel, firstLanTestInfo), (0, $6a559403926e01b7$export$1fed8e959d61377b)(eduLevel, exp)), (0, $6a559403926e01b7$export$79d91f9f33e2e534)(overseasExp, firstLanTestInfo), (0, $6a559403926e01b7$export$16e1782641a99723)(overseasExp, exp), (0, $6a559403926e01b7$export$94b3a8bd836596a5)((0, $6a559403926e01b7$export$79d91f9f33e2e534)(overseasExp, firstLanTestInfo), (0, $6a559403926e01b7$export$16e1782641a99723)(overseasExp, exp)), (0, $6a559403926e01b7$export$9cf1bc2acfeec73d)(hasCertificate, firstLanTestInfo), (0, $6a559403926e01b7$export$9cf1bc2acfeec73d)(hasCertificate, firstLanTestInfo), (0, $6a559403926e01b7$export$4bcec7b16b4a3a81)(600, (0, $6a559403926e01b7$export$fd41686132ea204)(hasProvincialNominee, employerType, canadaEduDegree, hasSibling, (0, $6a559403926e01b7$export$72af6bd96d26129a)(firstLanTestType, firstLanTestInfo, secondLanTestType, secondLanTestInfo))), hasProvincialNominee, onHasProvincialNomineeChanged, (0, $6a559403926e01b7$export$313c2cf4d32e1ee8)(hasProvincialNominee), (0, $a3a83d550ecd5f0d$export$ff5a5eabd004a88f).map((employerTypeName)=>(0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($9cbc01911585fbef$var$t22 || ($9cbc01911585fbef$var$t22 = $9cbc01911585fbef$var$_`<div class="radio">
                    <label>
                      <input
                        type="radio"
                        value=${0}
                        name="employerType"
                        ?checked=${0}
                        @change=${0}
                      />
                      ${0}
                    </label>
                  </div>`), employerTypeName, employerType === employerTypeName, onEmployerTypeChanged, employerTypeName)), (0, $6a559403926e01b7$export$5bcd3e6960cd8450)(employerType), (0, $6a559403926e01b7$export$6ae8ae1d77fc99c8)(canadaEduDegree), (0, $6a559403926e01b7$export$72af6bd96d26129a)(firstLanTestType, firstLanTestInfo, secondLanTestType, secondLanTestInfo), hasSibling, onHasSiblingChanged, (0, $6a559403926e01b7$export$b4ece03dd5931181)(hasSibling), (0, $6a559403926e01b7$export$4bcec7b16b4a3a81)(1200, (0, $6a559403926e01b7$export$9d5186fa87602c3e)((0, $6a559403926e01b7$export$a2af4d04d4184fe2)(age, isSingle), (0, $6a559403926e01b7$export$231d4b88776bb861)(eduLevel, isSingle, false), (0, $6a559403926e01b7$export$12b9b47f34fd261)(firstLanTestInfo, isSingle, false, true), (0, $6a559403926e01b7$export$4d121d8ff4b62f32)(exp, isSingle, false), (0, $6a559403926e01b7$export$12b9b47f34fd261)(secondLanTestInfo, isSingle, false, false), (0, $6a559403926e01b7$export$231d4b88776bb861)(spouseEduLevel, isSingle, true), (0, $6a559403926e01b7$export$12b9b47f34fd261)(spouseLanTestInfo, isSingle, true, false), (0, $6a559403926e01b7$export$4d121d8ff4b62f32)(spouseExp, isSingle, true), (0, $6a559403926e01b7$export$1cd02d2f0f702803)((0, $6a559403926e01b7$export$f72d9f2009fffb28)(eduLevel, firstLanTestInfo), (0, $6a559403926e01b7$export$1fed8e959d61377b)(eduLevel, exp)), (0, $6a559403926e01b7$export$94b3a8bd836596a5)((0, $6a559403926e01b7$export$79d91f9f33e2e534)(overseasExp, firstLanTestInfo), (0, $6a559403926e01b7$export$16e1782641a99723)(overseasExp, exp)), (0, $6a559403926e01b7$export$9cf1bc2acfeec73d)(hasCertificate, firstLanTestInfo), (0, $6a559403926e01b7$export$fd41686132ea204)(hasProvincialNominee, employerType, canadaEduDegree, hasSibling, (0, $6a559403926e01b7$export$72af6bd96d26129a)(firstLanTestType, firstLanTestInfo, secondLanTestType, secondLanTestInfo)))));
}
customElements.define("crs-form", (0, $4e8e25f2759d26d8$export$d8556a2a8f973135)($9cbc01911585fbef$var$CRSForm, {
    observedAttributes: [],
    useShadowDOM: false
}));



var $2c86def41536af6a$var$appleIphone = /iPhone/i;
var $2c86def41536af6a$var$appleIpod = /iPod/i;
var $2c86def41536af6a$var$appleTablet = /iPad/i;
var $2c86def41536af6a$var$appleUniversal = /\biOS-universal(?:.+)Mac\b/i;
var $2c86def41536af6a$var$androidPhone = /\bAndroid(?:.+)Mobile\b/i;
var $2c86def41536af6a$var$androidTablet = /Android/i;
var $2c86def41536af6a$var$amazonPhone = /(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i;
var $2c86def41536af6a$var$amazonTablet = /Silk/i;
var $2c86def41536af6a$var$windowsPhone = /Windows Phone/i;
var $2c86def41536af6a$var$windowsTablet = /\bWindows(?:.+)ARM\b/i;
var $2c86def41536af6a$var$otherBlackBerry = /BlackBerry/i;
var $2c86def41536af6a$var$otherBlackBerry10 = /BB10/i;
var $2c86def41536af6a$var$otherOpera = /Opera Mini/i;
var $2c86def41536af6a$var$otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
var $2c86def41536af6a$var$otherFirefox = /Mobile(?:.+)Firefox\b/i;
var $2c86def41536af6a$var$isAppleTabletOnIos13 = function(navigator1) {
    return typeof navigator1 !== "undefined" && navigator1.platform === "MacIntel" && typeof navigator1.maxTouchPoints === "number" && navigator1.maxTouchPoints > 1 && typeof MSStream === "undefined";
};
function $2c86def41536af6a$var$createMatch(userAgent) {
    return function(regex) {
        return regex.test(userAgent);
    };
}
function $2c86def41536af6a$export$2e2bcd8739ae039(param) {
    var nav = {
        userAgent: "",
        platform: "",
        maxTouchPoints: 0
    };
    if (!param && typeof navigator !== "undefined") nav = {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        maxTouchPoints: navigator.maxTouchPoints || 0
    };
    else if (typeof param === "string") nav.userAgent = param;
    else if (param && param.userAgent) nav = {
        userAgent: param.userAgent,
        platform: param.platform,
        maxTouchPoints: param.maxTouchPoints || 0
    };
    var userAgent = nav.userAgent;
    var tmp = userAgent.split("[FBAN");
    if (typeof tmp[1] !== "undefined") userAgent = tmp[0];
    tmp = userAgent.split("Twitter");
    if (typeof tmp[1] !== "undefined") userAgent = tmp[0];
    var match = $2c86def41536af6a$var$createMatch(userAgent);
    var result = {
        apple: {
            phone: match($2c86def41536af6a$var$appleIphone) && !match($2c86def41536af6a$var$windowsPhone),
            ipod: match($2c86def41536af6a$var$appleIpod),
            tablet: !match($2c86def41536af6a$var$appleIphone) && (match($2c86def41536af6a$var$appleTablet) || $2c86def41536af6a$var$isAppleTabletOnIos13(nav)) && !match($2c86def41536af6a$var$windowsPhone),
            universal: match($2c86def41536af6a$var$appleUniversal),
            device: (match($2c86def41536af6a$var$appleIphone) || match($2c86def41536af6a$var$appleIpod) || match($2c86def41536af6a$var$appleTablet) || match($2c86def41536af6a$var$appleUniversal) || $2c86def41536af6a$var$isAppleTabletOnIos13(nav)) && !match($2c86def41536af6a$var$windowsPhone)
        },
        amazon: {
            phone: match($2c86def41536af6a$var$amazonPhone),
            tablet: !match($2c86def41536af6a$var$amazonPhone) && match($2c86def41536af6a$var$amazonTablet),
            device: match($2c86def41536af6a$var$amazonPhone) || match($2c86def41536af6a$var$amazonTablet)
        },
        android: {
            phone: !match($2c86def41536af6a$var$windowsPhone) && match($2c86def41536af6a$var$amazonPhone) || !match($2c86def41536af6a$var$windowsPhone) && match($2c86def41536af6a$var$androidPhone),
            tablet: !match($2c86def41536af6a$var$windowsPhone) && !match($2c86def41536af6a$var$amazonPhone) && !match($2c86def41536af6a$var$androidPhone) && (match($2c86def41536af6a$var$amazonTablet) || match($2c86def41536af6a$var$androidTablet)),
            device: !match($2c86def41536af6a$var$windowsPhone) && (match($2c86def41536af6a$var$amazonPhone) || match($2c86def41536af6a$var$amazonTablet) || match($2c86def41536af6a$var$androidPhone) || match($2c86def41536af6a$var$androidTablet)) || match(/\bokhttp\b/i)
        },
        windows: {
            phone: match($2c86def41536af6a$var$windowsPhone),
            tablet: match($2c86def41536af6a$var$windowsTablet),
            device: match($2c86def41536af6a$var$windowsPhone) || match($2c86def41536af6a$var$windowsTablet)
        },
        other: {
            blackberry: match($2c86def41536af6a$var$otherBlackBerry),
            blackberry10: match($2c86def41536af6a$var$otherBlackBerry10),
            opera: match($2c86def41536af6a$var$otherOpera),
            firefox: match($2c86def41536af6a$var$otherFirefox),
            chrome: match($2c86def41536af6a$var$otherChrome),
            device: match($2c86def41536af6a$var$otherBlackBerry) || match($2c86def41536af6a$var$otherBlackBerry10) || match($2c86def41536af6a$var$otherOpera) || match($2c86def41536af6a$var$otherFirefox) || match($2c86def41536af6a$var$otherChrome)
        },
        any: false,
        phone: false,
        tablet: false
    };
    result.any = result.apple.device || result.android.device || result.windows.device || result.other.device;
    result.phone = result.apple.phone || result.android.phone || result.windows.phone;
    result.tablet = result.apple.tablet || result.android.tablet || result.windows.tablet;
    return result;
}




let $680e85cc4f03c205$var$_ = (t)=>t, $680e85cc4f03c205$var$t, $680e85cc4f03c205$var$t1, $680e85cc4f03c205$var$t2, $680e85cc4f03c205$var$t3;
const { userAgent: $680e85cc4f03c205$var$userAgent } = window.navigator;
function $680e85cc4f03c205$var$ServiceList() {
    const [services, setServices] = (0, $5cdad80541da5d1a$export$60241385465d0a34)([]);
    (0, $f7659344dcec8608$export$6d9c69b0de29b591)(async ()=>{
        const rawServices = await fetch("https://www.luckeducation.com/wp-json/wp/v2/service").then((response)=>response.json());
        const featuredImagePromises = rawServices.map((service)=>({
                id: service.id,
                featured_media: service.featured_media
            })).filter(({ featured_media: featured_media })=>featured_media).map(({ id: id, featured_media: featured_media })=>{
            return new Promise((resolve, reject)=>{
                fetch(`https://www.luckeducation.com/wp-json/wp/v2/media/${featured_media}`).then((response)=>response.json()).then((featured_media_info)=>{
                    resolve({
                        id: id,
                        imageUrl: featured_media_info.source_url
                    });
                });
            });
        });
        const featuredImages = await Promise.all(featuredImagePromises);
        const services = featuredImages.map(({ id: id, imageUrl: imageUrl })=>{
            const rawService = rawServices.find(({ id: rawId })=>id === rawId);
            return {
                id: id,
                imageUrl: imageUrl,
                title: rawService.title.rendered,
                link: rawService.link,
                slug: rawService.slug
            };
        });
        setServices(services);
    }, []);
    return (0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($680e85cc4f03c205$var$t3 || ($680e85cc4f03c205$var$t3 = $680e85cc4f03c205$var$_`<div class="gallery-wrapper raw no-gutters">
      ${0}
    </div>
    <style>
        .no-gutters
        > [class*="col-"] {
        padding-right: 0;
        padding-left: 0;
      }
      .hovereffect {
        width: 100%;
        height: 100%;
        float: left;
        overflow: hidden;
        position: relative;
        text-align: center;
        cursor: default;
        background: -webkit-linear-gradient(45deg, #ff89e9 0%, #05abe0 100%);
        background: linear-gradient(45deg, #ff89e9 0%, #05abe0 100%);
      }
      .hovereffect .overlay {
        width: 100%;
        height: 100%;
        position: absolute;
        overflow: hidden;
        top: 0;
        left: 0;
        padding: 3em;
        text-align: left;
      }
      .hovereffect img {
        display: block;
        position: relative;
        max-width: none;
        width: calc(100% + 60px);
        -webkit-transition: opacity 0.35s, -webkit-transform 0.45s;
        transition: opacity 0.35s, transform 0.45s;
        -webkit-transform: translate3d(-40px, 0, 0);
        transform: translate3d(-40px, 0, 0);
      }
      .hovereffect h2 {
        text-transform: uppercase;
        color: #fff;
        position: relative;
        font-size: 17px;
        background-color: transparent;
        text-align: left;
      }
      .hovereffect:hover .overlay:before {
        position: absolute;
        top: 20px;
        right: 20px;
        bottom: 20px;
        left: 20px;
        /* border: 2px solid #fff; */
        content: "";
        opacity: 0;
        filter: alpha(opacity=0);
        -webkit-transition: opacity 0.35s, -webkit-transform 0.45s;
        transition: opacity 0.35s, transform 0.45s;
        -webkit-transform: translate3d(-20px, 0, 0);
        transform: translate3d(-20px, 0, 0);
      }
      .hovereffect a,
      .hovereffect p {
        color: #fff;
        /* opacity: 0; */
        filter: alpha(opacity=0);
        -webkit-transition: opacity 0.35s, -webkit-transform 0.45s;
        transition: opacity 0.35s, transform 0.45s;
        -webkit-transform: translate3d(-10px, 0, 0);
        transform: translate3d(-10px, 0, 0);
      }
      .hovereffect:hover img {
        opacity: 0.6;
        filter: alpha(opacity=60);
        -webkit-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
      }
      .hovereffect:hover .overlay:before,
      .hovereffect:hover a,
      .hovereffect:hover p {
        opacity: 1;
        filter: alpha(opacity=100);
        -webkit-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
      }
      .hovereffect .overlay > a {
        visibility: hidden;
      }
      .hovereffect:hover .overlay > a {
        visibility: visible;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      ${0}
    </style>`), services.map((service)=>(0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($680e85cc4f03c205$var$t || ($680e85cc4f03c205$var$t = $680e85cc4f03c205$var$_`<div
            class="gallery-item service-${0} col-xs-12 col-sm-4"
          >
            <div class="hovereffect">
              <a href=${0}><img src=${0} /></a>
              <div class="overlay">
                <a href=${0}><h2>${0}</h2></a>
              </div>
            </div>
          </div>`), service.slug, service.link, service.imageUrl, service.link, service.title)), (0, $2c86def41536af6a$export$2e2bcd8739ae039)($680e85cc4f03c205$var$userAgent).any ? (0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($680e85cc4f03c205$var$t1 || ($680e85cc4f03c205$var$t1 = $680e85cc4f03c205$var$_`.hovereffect .overlay:before { position: absolute; top: 20px;
          right: 20px; bottom: 20px; left: 20px; content: ""; opacity: 0;
          filter: alpha(opacity=0); -webkit-transition: opacity 0.35s,
          -webkit-transform 0.45s; transition: opacity 0.35s, transform 0.45s;
          -webkit-transform: translate3d(-20px, 0, 0); transform:
          translate3d(-20px, 0, 0); } .hovereffect img { opacity: 0.6; filter:
          alpha(opacity=60); -webkit-transform: translate3d(0, 0, 0); transform:
          translate3d(0, 0, 0); } .hovereffect .overlay:before, .hovereffect a,
          .hovereffect p { opacity: 1; filter: alpha(opacity=100);
          -webkit-transform: translate3d(0, 0, 0); transform: translate3d(0, 0,
          0); } .hovereffect .overlay > a { visibility: visible; height: 100%;
          width: 100%; display: flex; align-items: center; justify-content:
          center; }`)) : (0, $da70b7db40529bd4$export$c0bb0b647f701bb5)($680e85cc4f03c205$var$t2 || ($680e85cc4f03c205$var$t2 = $680e85cc4f03c205$var$_``)));
}
customElements.define("service-list", (0, $4e8e25f2759d26d8$export$d8556a2a8f973135)($680e85cc4f03c205$var$ServiceList, {
    observedAttributes: [],
    useShadowDOM: false
}));



})();
//# sourceMappingURL=therewego-custom-script.js.map
